// 定义全国省份的数组
export const cityArr = [{ name: '北京', value: 1 },
  { name: '天津', value: 2 },
  { name: '河北', value: 5, selected: true },
  { name: '山西', value: 7 },
  { name: '内蒙古', value: 10 },
  { name: '辽宁', value: 12 },
  { name: '吉林', value: 15 },
  { name: '黑龙江', value: 18 },
  { name: '上海', value: 20 },
  { name: '江苏', value: 22 },
  { name: '浙江', value: 25 },
  { name: '安徽', value: 30 },
  { name: '福建', value: 34 },
  { name: '江西', value: 96 },
  { name: '山东', value: 92 },
  { name: '河南', value: 13 },
  { name: '湖北', value: 27 },
  { name: '湖南', value: 17 },
  { name: '广东', value: 38 },
  { name: '广西', value: 59 },
  { name: '海南', value: 54 },
  { name: '重庆', value: 66 },
  { name: '四川', value: 8 },
  { name: '贵州', value: 1 },
  { name: '云南', value: 25 },
  { name: '西藏', value: 24 },
  { name: '陕西', value: 25 },
  { name: '甘肃', value: 19 },
  { name: '青海', value: 17 },
  { name: '宁夏', value: 52 },
  { name: '新疆', value: 10 },
  { name: '台湾', value: 8 }
]

export const arr = [
  {
    name: '北京市',
    city: [
      {
        name: '北京市',
        county: [
          '东城区',
          '西城区',
          '朝阳区',
          '丰台区',
          '石景山区',
          '海淀区',
          '门头沟区',
          '房山区',
          '通州区',
          '顺义区',
          '昌平区',
          '大兴区',
          '怀柔区',
          '平谷区',
          '密云区',
          '延庆区'
        ]
      }
    ]
  },
  {
    name: '天津市',
    city: [
      {
        name: '天津市',
        county: [
          '和平区',
          '河东区',
          '河西区',
          '南开区',
          '河北区',
          '红桥区',
          '东丽区',
          '西青区',
          '津南区',
          '北辰区',
          '武清区',
          '宝坻区',
          '滨海新区',
          '宁河区',
          '静海区',
          '蓟州区'
        ]
      }
    ]
  },
  {
    name: '河北省',
    city: [
      {
        name: '石家庄市',
        county: [
          '长安区',
          '桥西区',
          '新华区',
          '井陉矿区',
          '裕华区',
          '藁城区',
          '鹿泉区',
          '栾城区',
          '井陉县',
          '正定县',
          '行唐县',
          '灵寿县',
          '高邑县',
          '深泽县',
          '赞皇县',
          '无极县',
          '平山县',
          '元氏县',
          '赵县',
          '晋州市',
          '新乐市'
        ]
      },
      {
        name: '唐山市',
        county: [
          '路南区',
          '路北区',
          '古冶区',
          '开平区',
          '丰南区',
          '丰润区',
          '曹妃甸区',
          '滦县',
          '滦南县',
          '乐亭县',
          '迁西县',
          '玉田县',
          '遵化市',
          '迁安市'
        ]
      },
      {
        name: '秦皇岛市',
        county: [
          '海港区',
          '山海关区',
          '北戴河区',
          '抚宁区',
          '青龙满族自治县',
          '昌黎县',
          '卢龙县'
        ]
      },
      {
        name: '邯郸市',
        county: [
          '邯山区',
          '丛台区',
          '复兴区',
          '峰峰矿区',
          '邯郸县',
          '临漳县',
          '成安县',
          '大名县',
          '涉县',
          '磁县',
          '肥乡县',
          '永年县',
          '邱县',
          '鸡泽县',
          '广平县',
          '馆陶县',
          '魏县',
          '曲周县',
          '武安市'
        ]
      },
      {
        name: '邢台市',
        county: [
          '桥东区',
          '桥西区',
          '邢台县',
          '临城县',
          '内丘县',
          '柏乡县',
          '隆尧县',
          '任县',
          '南和县',
          '宁晋县',
          '巨鹿县',
          '新河县',
          '广宗县',
          '平乡县',
          '威县',
          '清河县',
          '临西县',
          '南宫市',
          '沙河市'
        ]
      },
      {
        name: '保定市',
        county: [
          '竞秀区',
          '莲池区',
          '满城区',
          '清苑区',
          '徐水区',
          '涞水县',
          '阜平县',
          '定兴县',
          '唐县',
          '高阳县',
          '容城县',
          '涞源县',
          '望都县',
          '安新县',
          '易县',
          '曲阳县',
          '蠡县',
          '顺平县',
          '博野县',
          '雄县',
          '涿州市',
          '安国市',
          '高碑店市'
        ]
      },
      {
        name: '张家口市',
        county: [
          '桥东区',
          '桥西区',
          '宣化区',
          '下花园区',
          '万全区',
          '崇礼区',
          '张北县',
          '康保县',
          '沽源县',
          '尚义县',
          '蔚县',
          '阳原县',
          '怀安县',
          '怀来县',
          '涿鹿县',
          '赤城县'
        ]
      },
      {
        name: '承德市',
        county: [
          '双桥区',
          '双滦区',
          '鹰手营子矿区',
          '承德县',
          '兴隆县',
          '平泉县',
          '滦平县',
          '隆化县',
          '丰宁满族自治县',
          '宽城满族自治县',
          '围场满族蒙古族自治县'
        ]
      },
      {
        name: '沧州市',
        county: [
          '新华区',
          '运河区',
          '沧县',
          '青县',
          '东光县',
          '海兴县',
          '盐山县',
          '肃宁县',
          '南皮县',
          '吴桥县',
          '献县',
          '孟村回族自治县',
          '泊头市',
          '任丘市',
          '黄骅市',
          '河间市'
        ]
      },
      {
        name: '廊坊市',
        county: [
          '安次区',
          '广阳区',
          '固安县',
          '永清县',
          '香河县',
          '大城县',
          '文安县',
          '大厂回族自治县',
          '霸州市',
          '三河市'
        ]
      },
      {
        name: '衡水市',
        county: [
          '桃城区',
          '冀州区',
          '枣强县',
          '武邑县',
          '武强县',
          '饶阳县',
          '安平县',
          '故城县',
          '景县',
          '阜城县',
          '深州市'
        ]
      },
      {
        name: '省直辖县级行政区划',
        county: [
          '定州市',
          '辛集市'
        ]
      }
    ]
  },
  {
    name: '山西省',
    city: [
      {
        name: '太原市',
        county: [
          '小店区',
          '迎泽区',
          '杏花岭区',
          '尖草坪区',
          '万柏林区',
          '晋源区',
          '清徐县',
          '阳曲县',
          '娄烦县',
          '古交市'
        ]
      },
      {
        name: '大同市',
        county: [
          '城区',
          '矿区',
          '南郊区',
          '新荣区',
          '阳高县',
          '天镇县',
          '广灵县',
          '灵丘县',
          '浑源县',
          '左云县',
          '大同县'
        ]
      },
      {
        name: '阳泉市',
        county: [
          '城区',
          '矿区',
          '郊区',
          '平定县',
          '盂县'
        ]
      },
      {
        name: '长治市',
        county: [
          '城区',
          '郊区',
          '长治县',
          '襄垣县',
          '屯留县',
          '平顺县',
          '黎城县',
          '壶关县',
          '长子县',
          '武乡县',
          '沁县',
          '沁源县',
          '潞城市'
        ]
      },
      {
        name: '晋城市',
        county: [
          '城区',
          '沁水县',
          '阳城县',
          '陵川县',
          '泽州县',
          '高平市'
        ]
      },
      {
        name: '朔州市',
        county: [
          '朔城区',
          '平鲁区',
          '山阴县',
          '应县',
          '右玉县',
          '怀仁县'
        ]
      },
      {
        name: '晋中市',
        county: [
          '榆次区',
          '榆社县',
          '左权县',
          '和顺县',
          '昔阳县',
          '寿阳县',
          '太谷县',
          '祁县',
          '平遥县',
          '灵石县',
          '介休市'
        ]
      },
      {
        name: '运城市',
        county: [
          '盐湖区',
          '临猗县',
          '万荣县',
          '闻喜县',
          '稷山县',
          '新绛县',
          '绛县',
          '垣曲县',
          '夏县',
          '平陆县',
          '芮城县',
          '永济市',
          '河津市'
        ]
      },
      {
        name: '忻州市',
        county: [
          '忻府区',
          '定襄县',
          '五台县',
          '代县',
          '繁峙县',
          '宁武县',
          '静乐县',
          '神池县',
          '五寨县',
          '岢岚县',
          '河曲县',
          '保德县',
          '偏关县',
          '原平市'
        ]
      },
      {
        name: '临汾市',
        county: [
          '尧都区',
          '曲沃县',
          '翼城县',
          '襄汾县',
          '洪洞县',
          '古县',
          '安泽县',
          '浮山县',
          '吉县',
          '乡宁县',
          '大宁县',
          '隰县',
          '永和县',
          '蒲县',
          '汾西县',
          '侯马市',
          '霍州市'
        ]
      },
      {
        name: '吕梁市',
        county: [
          '离石区',
          '文水县',
          '交城县',
          '兴县',
          '临县',
          '柳林县',
          '石楼县',
          '岚县',
          '方山县',
          '中阳县',
          '交口县',
          '孝义市',
          '汾阳市'
        ]
      }
    ]
  },
  {
    name: '内蒙古自治区',
    city: [
      {
        name: '呼和浩特市',
        county: [
          '新城区',
          '回民区',
          '玉泉区',
          '赛罕区',
          '土默特左旗',
          '托克托县',
          '和林格尔县',
          '清水河县',
          '武川县'
        ]
      },
      {
        name: '包头市',
        county: [
          '东河区',
          '昆都仑区',
          '青山区',
          '石拐区',
          '白云鄂博矿区',
          '九原区',
          '土默特右旗',
          '固阳县',
          '达尔罕茂明安联合旗'
        ]
      },
      {
        name: '乌海市',
        county: [
          '海勃湾区',
          '海南区',
          '乌达区'
        ]
      },
      {
        name: '赤峰市',
        county: [
          '红山区',
          '元宝山区',
          '松山区',
          '阿鲁科尔沁旗',
          '巴林左旗',
          '巴林右旗',
          '林西县',
          '克什克腾旗',
          '翁牛特旗',
          '喀喇沁旗',
          '宁城县',
          '敖汉旗'
        ]
      },
      {
        name: '通辽市',
        county: [
          '科尔沁区',
          '科尔沁左翼中旗',
          '科尔沁左翼后旗',
          '开鲁县',
          '库伦旗',
          '奈曼旗',
          '扎鲁特旗',
          '霍林郭勒市'
        ]
      },
      {
        name: '鄂尔多斯市',
        county: [
          '东胜区',
          '康巴什区',
          '达拉特旗',
          '准格尔旗',
          '鄂托克前旗',
          '鄂托克旗',
          '杭锦旗',
          '乌审旗',
          '伊金霍洛旗'
        ]
      },
      {
        name: '呼伦贝尔市',
        county: [
          '海拉尔区',
          '扎赉诺尔区',
          '阿荣旗',
          '莫力达瓦达斡尔族自治旗',
          '鄂伦春自治旗',
          '鄂温克族自治旗',
          '陈巴尔虎旗',
          '新巴尔虎左旗',
          '新巴尔虎右旗',
          '满洲里市',
          '牙克石市',
          '扎兰屯市',
          '额尔古纳市',
          '根河市'
        ]
      },
      {
        name: '巴彦淖尔市',
        county: [
          '临河区',
          '五原县',
          '磴口县',
          '乌拉特前旗',
          '乌拉特中旗',
          '乌拉特后旗',
          '杭锦后旗'
        ]
      },
      {
        name: '乌兰察布市',
        county: [
          '集宁区',
          '卓资县',
          '化德县',
          '商都县',
          '兴和县',
          '凉城县',
          '察哈尔右翼前旗',
          '察哈尔右翼中旗',
          '察哈尔右翼后旗',
          '四子王旗',
          '丰镇市'
        ]
      },
      {
        name: '兴安盟',
        county: [
          '乌兰浩特市',
          '阿尔山市',
          '科尔沁右翼前旗',
          '科尔沁右翼中旗',
          '扎赉特旗',
          '突泉县'
        ]
      },
      {
        name: '锡林郭勒盟',
        county: [
          '二连浩特市',
          '锡林浩特市',
          '阿巴嘎旗',
          '苏尼特左旗',
          '苏尼特右旗',
          '东乌珠穆沁旗',
          '西乌珠穆沁旗',
          '太仆寺旗',
          '镶黄旗',
          '正镶白旗',
          '正蓝旗',
          '多伦县'
        ]
      },
      {
        name: '阿拉善盟',
        county: [
          '阿拉善左旗',
          '阿拉善右旗',
          '额济纳旗'
        ]
      }
    ]
  },
  {
    name: '辽宁省',
    city: [
      {
        name: '沈阳市',
        county: [
          '和平区',
          '沈河区',
          '大东区',
          '皇姑区',
          '铁西区',
          '苏家屯区',
          '浑南区',
          '沈北新区',
          '于洪区',
          '辽中区',
          '康平县',
          '法库县',
          '新民市'
        ]
      },
      {
        name: '大连市',
        county: [
          '中山区',
          '西岗区',
          '沙河口区',
          '甘井子区',
          '旅顺口区',
          '金州区',
          '普兰店区',
          '长海县',
          '瓦房店市',
          '庄河市'
        ]
      },
      {
        name: '鞍山市',
        county: [
          '铁东区',
          '铁西区',
          '立山区',
          '千山区',
          '台安县',
          '岫岩满族自治县',
          '海城市'
        ]
      },
      {
        name: '抚顺市',
        county: [
          '新抚区',
          '东洲区',
          '望花区',
          '顺城区',
          '抚顺县',
          '新宾满族自治县',
          '清原满族自治县'
        ]
      },
      {
        name: '本溪市',
        county: [
          '平山区',
          '溪湖区',
          '明山区',
          '南芬区',
          '本溪满族自治县',
          '桓仁满族自治县'
        ]
      },
      {
        name: '丹东市',
        county: [
          '元宝区',
          '振兴区',
          '振安区',
          '宽甸满族自治县',
          '东港市',
          '凤城市'
        ]
      },
      {
        name: '锦州市',
        county: [
          '古塔区',
          '凌河区',
          '太和区',
          '黑山县',
          '义县',
          '凌海市',
          '北镇市'
        ]
      },
      {
        name: '营口市',
        county: [
          '站前区',
          '西市区',
          '鲅鱼圈区',
          '老边区',
          '盖州市',
          '大石桥市'
        ]
      },
      {
        name: '阜新市',
        county: [
          '海州区',
          '新邱区',
          '太平区',
          '清河门区',
          '细河区',
          '阜新蒙古族自治县',
          '彰武县'
        ]
      },
      {
        name: '辽阳市',
        county: [
          '白塔区',
          '文圣区',
          '宏伟区',
          '弓长岭区',
          '太子河区',
          '辽阳县',
          '灯塔市'
        ]
      },
      {
        name: '盘锦市',
        county: [
          '双台子区',
          '兴隆台区',
          '大洼区',
          '盘山县'
        ]
      },
      {
        name: '铁岭市',
        county: [
          '银州区',
          '清河区',
          '铁岭县',
          '西丰县',
          '昌图县',
          '调兵山市',
          '开原市'
        ]
      },
      {
        name: '朝阳市',
        county: [
          '双塔区',
          '龙城区',
          '朝阳县',
          '建平县',
          '喀喇沁左翼蒙古族自治县',
          '北票市',
          '凌源市'
        ]
      },
      {
        name: '葫芦岛市',
        county: [
          '连山区',
          '龙港区',
          '南票区',
          '绥中县',
          '建昌县',
          '兴城市'
        ]
      }
    ]
  },
  {
    name: '吉林省',
    city: [
      {
        name: '长春市',
        county: [
          '南关区',
          '宽城区',
          '朝阳区',
          '二道区',
          '绿园区',
          '双阳区',
          '九台区',
          '农安县',
          '榆树市',
          '德惠市'
        ]
      },
      {
        name: '吉林市',
        county: [
          '昌邑区',
          '龙潭区',
          '船营区',
          '丰满区',
          '永吉县',
          '蛟河市',
          '桦甸市',
          '舒兰市',
          '磐石市'
        ]
      },
      {
        name: '四平市',
        county: [
          '铁西区',
          '铁东区',
          '梨树县',
          '伊通满族自治县',
          '公主岭市',
          '双辽市'
        ]
      },
      {
        name: '辽源市',
        county: [
          '龙山区',
          '西安区',
          '东丰县',
          '东辽县'
        ]
      },
      {
        name: '通化市',
        county: [
          '东昌区',
          '二道江区',
          '通化县',
          '辉南县',
          '柳河县',
          '梅河口市',
          '集安市'
        ]
      },
      {
        name: '白山市',
        county: [
          '浑江区',
          '江源区',
          '抚松县',
          '靖宇县',
          '长白朝鲜族自治县',
          '临江市'
        ]
      },
      {
        name: '松原市',
        county: [
          '宁江区',
          '前郭尔罗斯蒙古族自治县',
          '长岭县',
          '乾安县',
          '扶余市'
        ]
      },
      {
        name: '白城市',
        county: [
          '洮北区',
          '镇赉县',
          '通榆县',
          '洮南市',
          '大安市'
        ]
      },
      {
        name: '延边朝鲜族自治州',
        county: [
          '延吉市',
          '图们市',
          '敦化市',
          '珲春市',
          '龙井市',
          '和龙市',
          '汪清县',
          '安图县'
        ]
      }
    ]
  },
  {
    name: '黑龙江省',
    city: [
      {
        name: '哈尔滨市',
        county: [
          '道里区',
          '南岗区',
          '道外区',
          '平房区',
          '松北区',
          '香坊区',
          '呼兰区',
          '阿城区',
          '双城区',
          '依兰县',
          '方正县',
          '宾县',
          '巴彦县',
          '木兰县',
          '通河县',
          '延寿县',
          '尚志市',
          '五常市'
        ]
      },
      {
        name: '齐齐哈尔市',
        county: [
          '龙沙区',
          '建华区',
          '铁锋区',
          '昂昂溪区',
          '富拉尔基区',
          '碾子山区',
          '梅里斯达斡尔族区',
          '龙江县',
          '依安县',
          '泰来县',
          '甘南县',
          '富裕县',
          '克山县',
          '克东县',
          '拜泉县',
          '讷河市'
        ]
      },
      {
        name: '鸡西市',
        county: [
          '鸡冠区',
          '恒山区',
          '滴道区',
          '梨树区',
          '城子河区',
          '麻山区',
          '鸡东县',
          '虎林市',
          '密山市'
        ]
      },
      {
        name: '鹤岗市',
        county: [
          '向阳区',
          '工农区',
          '南山区',
          '兴安区',
          '东山区',
          '兴山区',
          '萝北县',
          '绥滨县'
        ]
      },
      {
        name: '双鸭山市',
        county: [
          '尖山区',
          '岭东区',
          '四方台区',
          '宝山区',
          '集贤县',
          '友谊县',
          '宝清县',
          '饶河县'
        ]
      },
      {
        name: '大庆市',
        county: [
          '萨尔图区',
          '龙凤区',
          '让胡路区',
          '红岗区',
          '大同区',
          '肇州县',
          '肇源县',
          '林甸县',
          '杜尔伯特蒙古族自治县'
        ]
      },
      {
        name: '伊春市',
        county: [
          '伊春区',
          '南岔区',
          '友好区',
          '西林区',
          '翠峦区',
          '新青区',
          '美溪区',
          '金山屯区',
          '五营区',
          '乌马河区',
          '汤旺河区',
          '带岭区',
          '乌伊岭区',
          '红星区',
          '上甘岭区',
          '嘉荫县',
          '铁力市'
        ]
      },
      {
        name: '佳木斯市',
        county: [
          '向阳区',
          '前进区',
          '东风区',
          '郊区',
          '桦南县',
          '桦川县',
          '汤原县',
          '同江市',
          '富锦市',
          '抚远市'
        ]
      },
      {
        name: '七台河市',
        county: [
          '新兴区',
          '桃山区',
          '茄子河区',
          '勃利县'
        ]
      },
      {
        name: '牡丹江市',
        county: [
          '东安区',
          '阳明区',
          '爱民区',
          '西安区',
          '林口县',
          '绥芬河市',
          '海林市',
          '宁安市',
          '穆棱市',
          '东宁市'
        ]
      },
      {
        name: '黑河市',
        county: [
          '爱辉区',
          '嫩江县',
          '逊克县',
          '孙吴县',
          '北安市',
          '五大连池市'
        ]
      },
      {
        name: '绥化市',
        county: [
          '北林区',
          '望奎县',
          '兰西县',
          '青冈县',
          '庆安县',
          '明水县',
          '绥棱县',
          '安达市',
          '肇东市',
          '海伦市'
        ]
      },
      {
        name: '大兴安岭地区',
        county: [
          '呼玛县',
          '塔河县',
          '漠河县'
        ]
      }
    ]
  },
  {
    name: '上海市',
    city: [
      {
        name: '上海市',
        county: [
          '黄浦区',
          '徐汇区',
          '长宁区',
          '静安区',
          '普陀区',
          '虹口区',
          '杨浦区',
          '闵行区',
          '宝山区',
          '嘉定区',
          '浦东新区',
          '金山区',
          '松江区',
          '青浦区',
          '奉贤区',
          '崇明区'
        ]
      }
    ]
  },
  {
    name: '江苏省',
    city: [
      {
        name: '南京市',
        county: [
          '玄武区',
          '秦淮区',
          '建邺区',
          '鼓楼区',
          '浦口区',
          '栖霞区',
          '雨花台区',
          '江宁区',
          '六合区',
          '溧水区',
          '高淳区'
        ]
      },
      {
        name: '无锡市',
        county: [
          '锡山区',
          '惠山区',
          '滨湖区',
          '梁溪区',
          '新吴区',
          '江阴市',
          '宜兴市'
        ]
      },
      {
        name: '徐州市',
        county: [
          '鼓楼区',
          '云龙区',
          '贾汪区',
          '泉山区',
          '铜山区',
          '丰县',
          '沛县',
          '睢宁县',
          '新沂市',
          '邳州市'
        ]
      },
      {
        name: '常州市',
        county: [
          '天宁区',
          '钟楼区',
          '新北区',
          '武进区',
          '金坛区',
          '溧阳市'
        ]
      },
      {
        name: '苏州市',
        county: [
          '虎丘区',
          '吴中区',
          '相城区',
          '姑苏区',
          '吴江区',
          '常熟市',
          '张家港市',
          '昆山市',
          '太仓市'
        ]
      },
      {
        name: '南通市',
        county: [
          '崇川区',
          '港闸区',
          '通州区',
          '海安县',
          '如东县',
          '启东市',
          '如皋市',
          '海门市'
        ]
      },
      {
        name: '连云港市',
        county: [
          '连云区',
          '海州区',
          '赣榆区',
          '东海县',
          '灌云县',
          '灌南县'
        ]
      },
      {
        name: '淮安市',
        county: [
          '淮安区',
          '淮阴区',
          '清江浦区',
          '洪泽区',
          '涟水县',
          '盱眙县',
          '金湖县'
        ]
      },
      {
        name: '盐城市',
        county: [
          '亭湖区',
          '盐都区',
          '大丰区',
          '响水县',
          '滨海县',
          '阜宁县',
          '射阳县',
          '建湖县',
          '东台市'
        ]
      },
      {
        name: '扬州市',
        county: [
          '广陵区',
          '邗江区',
          '江都区',
          '宝应县',
          '仪征市',
          '高邮市'
        ]
      },
      {
        name: '镇江市',
        county: [
          '京口区',
          '润州区',
          '丹徒区',
          '丹阳市',
          '扬中市',
          '句容市'
        ]
      },
      {
        name: '泰州市',
        county: [
          '海陵区',
          '高港区',
          '姜堰区',
          '兴化市',
          '靖江市',
          '泰兴市'
        ]
      },
      {
        name: '宿迁市',
        county: [
          '宿城区',
          '宿豫区',
          '沭阳县',
          '泗阳县',
          '泗洪县'
        ]
      }
    ]
  },
  {
    name: '浙江省',
    city: [
      {
        name: '杭州市',
        county: [
          '上城区',
          '下城区',
          '江干区',
          '拱墅区',
          '西湖区',
          '滨江区',
          '萧山区',
          '余杭区',
          '富阳区',
          '桐庐县',
          '淳安县',
          '建德市',
          '临安市'
        ]
      },
      {
        name: '宁波市',
        county: [
          '海曙区',
          '江东区',
          '江北区',
          '北仑区',
          '镇海区',
          '鄞州区',
          '象山县',
          '宁海县',
          '余姚市',
          '慈溪市',
          '奉化市'
        ]
      },
      {
        name: '温州市',
        county: [
          '鹿城区',
          '龙湾区',
          '瓯海区',
          '洞头区',
          '永嘉县',
          '平阳县',
          '苍南县',
          '文成县',
          '泰顺县',
          '瑞安市',
          '乐清市'
        ]
      },
      {
        name: '嘉兴市',
        county: [
          '南湖区',
          '秀洲区',
          '嘉善县',
          '海盐县',
          '海宁市',
          '平湖市',
          '桐乡市'
        ]
      },
      {
        name: '湖州市',
        county: [
          '吴兴区',
          '南浔区',
          '德清县',
          '长兴县',
          '安吉县'
        ]
      },
      {
        name: '绍兴市',
        county: [
          '越城区',
          '柯桥区',
          '上虞区',
          '新昌县',
          '诸暨市',
          '嵊州市'
        ]
      },
      {
        name: '金华市',
        county: [
          '婺城区',
          '金东区',
          '武义县',
          '浦江县',
          '磐安县',
          '兰溪市',
          '义乌市',
          '东阳市',
          '永康市'
        ]
      },
      {
        name: '衢州市',
        county: [
          '柯城区',
          '衢江区',
          '常山县',
          '开化县',
          '龙游县',
          '江山市'
        ]
      },
      {
        name: '舟山市',
        county: [
          '定海区',
          '普陀区',
          '岱山县',
          '嵊泗县'
        ]
      },
      {
        name: '台州市',
        county: [
          '椒江区',
          '黄岩区',
          '路桥区',
          '玉环县',
          '三门县',
          '天台县',
          '仙居县',
          '温岭市',
          '临海市'
        ]
      },
      {
        name: '丽水市',
        county: [
          '莲都区',
          '青田县',
          '缙云县',
          '遂昌县',
          '松阳县',
          '云和县',
          '庆元县',
          '景宁畲族自治县',
          '龙泉市'
        ]
      }
    ]
  },
  {
    name: '安徽省',
    city: [
      {
        name: '合肥市',
        county: [
          '瑶海区',
          '庐阳区',
          '蜀山区',
          '包河区',
          '长丰县',
          '肥东县',
          '肥西县',
          '庐江县',
          '巢湖市'
        ]
      },
      {
        name: '芜湖市',
        county: [
          '镜湖区',
          '弋江区',
          '鸠江区',
          '三山区',
          '芜湖县',
          '繁昌县',
          '南陵县',
          '无为县'
        ]
      },
      {
        name: '蚌埠市',
        county: [
          '龙子湖区',
          '蚌山区',
          '禹会区',
          '淮上区',
          '怀远县',
          '五河县',
          '固镇县'
        ]
      },
      {
        name: '淮南市',
        county: [
          '大通区',
          '田家庵区',
          '谢家集区',
          '八公山区',
          '潘集区',
          '凤台县',
          '寿县'
        ]
      },
      {
        name: '马鞍山市',
        county: [
          '花山区',
          '雨山区',
          '博望区',
          '当涂县',
          '含山县',
          '和县'
        ]
      },
      {
        name: '淮北市',
        county: [
          '杜集区',
          '相山区',
          '烈山区',
          '濉溪县'
        ]
      },
      {
        name: '铜陵市',
        county: [
          '铜官区',
          '义安区',
          '郊区',
          '枞阳县'
        ]
      },
      {
        name: '安庆市',
        county: [
          '迎江区',
          '大观区',
          '宜秀区',
          '怀宁县',
          '潜山县',
          '太湖县',
          '宿松县',
          '望江县',
          '岳西县',
          '桐城市'
        ]
      },
      {
        name: '黄山市',
        county: [
          '屯溪区',
          '黄山区',
          '徽州区',
          '歙县',
          '休宁县',
          '黟县',
          '祁门县'
        ]
      },
      {
        name: '滁州市',
        county: [
          '琅琊区',
          '南谯区',
          '来安县',
          '全椒县',
          '定远县',
          '凤阳县',
          '天长市',
          '明光市'
        ]
      },
      {
        name: '阜阳市',
        county: [
          '颍州区',
          '颍东区',
          '颍泉区',
          '临泉县',
          '太和县',
          '阜南县',
          '颍上县',
          '界首市'
        ]
      },
      {
        name: '宿州市',
        county: [
          '埇桥区',
          '砀山县',
          '萧县',
          '灵璧县',
          '泗县'
        ]
      },
      {
        name: '六安市',
        county: [
          '金安区',
          '裕安区',
          '叶集区',
          '霍邱县',
          '舒城县',
          '金寨县',
          '霍山县'
        ]
      },
      {
        name: '亳州市',
        county: [
          '谯城区',
          '涡阳县',
          '蒙城县',
          '利辛县'
        ]
      },
      {
        name: '池州市',
        county: [
          '贵池区',
          '东至县',
          '石台县',
          '青阳县'
        ]
      },
      {
        name: '宣城市',
        county: [
          '宣州区',
          '郎溪县',
          '广德县',
          '泾县',
          '绩溪县',
          '旌德县',
          '宁国市'
        ]
      }
    ]
  },
  {
    name: '福建省',
    city: [
      {
        name: '福州市',
        county: [
          '鼓楼区',
          '台江区',
          '仓山区',
          '马尾区',
          '晋安区',
          '闽侯县',
          '连江县',
          '罗源县',
          '闽清县',
          '永泰县',
          '平潭县',
          '福清市',
          '长乐市'
        ]
      },
      {
        name: '厦门市',
        county: [
          '思明区',
          '海沧区',
          '湖里区',
          '集美区',
          '同安区',
          '翔安区'
        ]
      },
      {
        name: '莆田市',
        county: [
          '城厢区',
          '涵江区',
          '荔城区',
          '秀屿区',
          '仙游县'
        ]
      },
      {
        name: '三明市',
        county: [
          '梅列区',
          '三元区',
          '明溪县',
          '清流县',
          '宁化县',
          '大田县',
          '尤溪县',
          '沙县',
          '将乐县',
          '泰宁县',
          '建宁县',
          '永安市'
        ]
      },
      {
        name: '泉州市',
        county: [
          '鲤城区',
          '丰泽区',
          '洛江区',
          '泉港区',
          '惠安县',
          '安溪县',
          '永春县',
          '德化县',
          '金门县',
          '石狮市',
          '晋江市',
          '南安市'
        ]
      },
      {
        name: '漳州市',
        county: [
          '芗城区',
          '龙文区',
          '云霄县',
          '漳浦县',
          '诏安县',
          '长泰县',
          '东山县',
          '南靖县',
          '平和县',
          '华安县',
          '龙海市'
        ]
      },
      {
        name: '南平市',
        county: [
          '延平区',
          '建阳区',
          '顺昌县',
          '浦城县',
          '光泽县',
          '松溪县',
          '政和县',
          '邵武市',
          '武夷山市',
          '建瓯市'
        ]
      },
      {
        name: '龙岩市',
        county: [
          '新罗区',
          '永定区',
          '长汀县',
          '上杭县',
          '武平县',
          '连城县',
          '漳平市'
        ]
      },
      {
        name: '宁德市',
        county: [
          '蕉城区',
          '霞浦县',
          '古田县',
          '屏南县',
          '寿宁县',
          '周宁县',
          '柘荣县',
          '福安市',
          '福鼎市'
        ]
      }
    ]
  },
  {
    name: '江西省',
    city: [
      {
        name: '南昌市',
        county: [
          '东湖区',
          '西湖区',
          '青云谱区',
          '湾里区',
          '青山湖区',
          '新建区',
          '南昌县',
          '安义县',
          '进贤县'
        ]
      },
      {
        name: '景德镇市',
        county: [
          '昌江区',
          '珠山区',
          '浮梁县',
          '乐平市'
        ]
      },
      {
        name: '萍乡市',
        county: [
          '安源区',
          '湘东区',
          '莲花县',
          '上栗县',
          '芦溪县'
        ]
      },
      {
        name: '九江市',
        county: [
          '濂溪区',
          '浔阳区',
          '九江县',
          '武宁县',
          '修水县',
          '永修县',
          '德安县',
          '都昌县',
          '湖口县',
          '彭泽县',
          '瑞昌市',
          '共青城市',
          '庐山市'
        ]
      },
      {
        name: '新余市',
        county: [
          '渝水区',
          '分宜县'
        ]
      },
      {
        name: '鹰潭市',
        county: [
          '月湖区',
          '余江县',
          '贵溪市'
        ]
      },
      {
        name: '赣州市',
        county: [
          '章贡区',
          '南康区',
          '赣县',
          '信丰县',
          '大余县',
          '上犹县',
          '崇义县',
          '安远县',
          '龙南县',
          '定南县',
          '全南县',
          '宁都县',
          '于都县',
          '兴国县',
          '会昌县',
          '寻乌县',
          '石城县',
          '瑞金市'
        ]
      },
      {
        name: '吉安市',
        county: [
          '吉州区',
          '青原区',
          '吉安县',
          '吉水县',
          '峡江县',
          '新干县',
          '永丰县',
          '泰和县',
          '遂川县',
          '万安县',
          '安福县',
          '永新县',
          '井冈山市'
        ]
      },
      {
        name: '宜春市',
        county: [
          '袁州区',
          '奉新县',
          '万载县',
          '上高县',
          '宜丰县',
          '靖安县',
          '铜鼓县',
          '丰城市',
          '樟树市',
          '高安市'
        ]
      },
      {
        name: '抚州市',
        county: [
          '临川区',
          '南城县',
          '黎川县',
          '南丰县',
          '崇仁县',
          '乐安县',
          '宜黄县',
          '金溪县',
          '资溪县',
          '东乡县',
          '广昌县'
        ]
      },
      {
        name: '上饶市',
        county: [
          '信州区',
          '广丰区',
          '上饶县',
          '玉山县',
          '铅山县',
          '横峰县',
          '弋阳县',
          '余干县',
          '鄱阳县',
          '万年县',
          '婺源县',
          '德兴市'
        ]
      }
    ]
  },
  {
    name: '山东省',
    city: [
      {
        name: '济南市',
        county: [
          '历下区',
          '市中区',
          '槐荫区',
          '天桥区',
          '历城区',
          '长清区',
          '平阴县',
          '济阳县',
          '商河县',
          '章丘市'
        ]
      },
      {
        name: '青岛市',
        county: [
          '市南区',
          '市北区',
          '黄岛区',
          '崂山区',
          '李沧区',
          '城阳区',
          '胶州市',
          '即墨市',
          '平度市',
          '莱西市'
        ]
      },
      {
        name: '淄博市',
        county: [
          '淄川区',
          '张店区',
          '博山区',
          '临淄区',
          '周村区',
          '桓台县',
          '高青县',
          '沂源县'
        ]
      },
      {
        name: '枣庄市',
        county: [
          '市中区',
          '薛城区',
          '峄城区',
          '台儿庄区',
          '山亭区',
          '滕州市'
        ]
      },
      {
        name: '东营市',
        county: [
          '东营区',
          '河口区',
          '垦利区',
          '利津县',
          '广饶县'
        ]
      },
      {
        name: '烟台市',
        county: [
          '芝罘区',
          '福山区',
          '牟平区',
          '莱山区',
          '长岛县',
          '龙口市',
          '莱阳市',
          '莱州市',
          '蓬莱市',
          '招远市',
          '栖霞市',
          '海阳市'
        ]
      },
      {
        name: '潍坊市',
        county: [
          '潍城区',
          '寒亭区',
          '坊子区',
          '奎文区',
          '临朐县',
          '昌乐县',
          '青州市',
          '诸城市',
          '寿光市',
          '安丘市',
          '高密市',
          '昌邑市'
        ]
      },
      {
        name: '济宁市',
        county: [
          '任城区',
          '兖州区',
          '微山县',
          '鱼台县',
          '金乡县',
          '嘉祥县',
          '汶上县',
          '泗水县',
          '梁山县',
          '曲阜市',
          '邹城市'
        ]
      },
      {
        name: '泰安市',
        county: [
          '泰山区',
          '岱岳区',
          '宁阳县',
          '东平县',
          '新泰市',
          '肥城市'
        ]
      },
      {
        name: '威海市',
        county: [
          '环翠区',
          '文登区',
          '荣成市',
          '乳山市'
        ]
      },
      {
        name: '日照市',
        county: [
          '东港区',
          '岚山区',
          '五莲县',
          '莒县'
        ]
      },
      {
        name: '莱芜市',
        county: [
          '莱城区',
          '钢城区'
        ]
      },
      {
        name: '临沂市',
        county: [
          '兰山区',
          '罗庄区',
          '河东区',
          '沂南县',
          '郯城县',
          '沂水县',
          '兰陵县',
          '费县',
          '平邑县',
          '莒南县',
          '蒙阴县',
          '临沭县'
        ]
      },
      {
        name: '德州市',
        county: [
          '德城区',
          '陵城区',
          '宁津县',
          '庆云县',
          '临邑县',
          '齐河县',
          '平原县',
          '夏津县',
          '武城县',
          '乐陵市',
          '禹城市'
        ]
      },
      {
        name: '聊城市',
        county: [
          '东昌府区',
          '阳谷县',
          '莘县',
          '茌平县',
          '东阿县',
          '冠县',
          '高唐县',
          '临清市'
        ]
      },
      {
        name: '滨州市',
        county: [
          '滨城区',
          '沾化区',
          '惠民县',
          '阳信县',
          '无棣县',
          '博兴县',
          '邹平县'
        ]
      },
      {
        name: '菏泽市',
        county: [
          '牡丹区',
          '定陶区',
          '曹县',
          '单县',
          '成武县',
          '巨野县',
          '郓城县',
          '鄄城县',
          '东明县'
        ]
      }
    ]
  },
  {
    name: '河南省',
    city: [
      {
        name: '郑州市',
        county: [
          '中原区',
          '二七区',
          '管城回族区',
          '金水区',
          '上街区',
          '惠济区',
          '中牟县',
          '巩义市',
          '荥阳市',
          '新密市',
          '新郑市',
          '登封市'
        ]
      },
      {
        name: '开封市',
        county: [
          '龙亭区',
          '顺河回族区',
          '鼓楼区',
          '禹王台区',
          '金明区',
          '祥符区',
          '杞县',
          '通许县',
          '尉氏县',
          '兰考县'
        ]
      },
      {
        name: '洛阳市',
        county: [
          '老城区',
          '西工区',
          '瀍河回族区',
          '涧西区',
          '吉利区',
          '洛龙区',
          '孟津县',
          '新安县',
          '栾川县',
          '嵩县',
          '汝阳县',
          '宜阳县',
          '洛宁县',
          '伊川县',
          '偃师市'
        ]
      },
      {
        name: '平顶山市',
        county: [
          '新华区',
          '卫东区',
          '石龙区',
          '湛河区',
          '宝丰县',
          '叶县',
          '鲁山县',
          '郏县',
          '舞钢市',
          '汝州市'
        ]
      },
      {
        name: '安阳市',
        county: [
          '文峰区',
          '北关区',
          '殷都区',
          '龙安区',
          '安阳县',
          '汤阴县',
          '滑县',
          '内黄县',
          '林州市'
        ]
      },
      {
        name: '鹤壁市',
        county: [
          '鹤山区',
          '山城区',
          '淇滨区',
          '浚县',
          '淇县'
        ]
      },
      {
        name: '新乡市',
        county: [
          '红旗区',
          '卫滨区',
          '凤泉区',
          '牧野区',
          '新乡县',
          '获嘉县',
          '原阳县',
          '延津县',
          '封丘县',
          '长垣县',
          '卫辉市',
          '辉县市'
        ]
      },
      {
        name: '焦作市',
        county: [
          '解放区',
          '中站区',
          '马村区',
          '山阳区',
          '修武县',
          '博爱县',
          '武陟县',
          '温县',
          '沁阳市',
          '孟州市'
        ]
      },
      {
        name: '濮阳市',
        county: [
          '华龙区',
          '清丰县',
          '南乐县',
          '范县',
          '台前县',
          '濮阳县'
        ]
      },
      {
        name: '许昌市',
        county: [
          '魏都区',
          '许昌县',
          '鄢陵县',
          '襄城县',
          '禹州市',
          '长葛市'
        ]
      },
      {
        name: '漯河市',
        county: [
          '源汇区',
          '郾城区',
          '召陵区',
          '舞阳县',
          '临颍县'
        ]
      },
      {
        name: '三门峡市',
        county: [
          '湖滨区',
          '陕州区',
          '渑池县',
          '卢氏县',
          '义马市',
          '灵宝市'
        ]
      },
      {
        name: '南阳市',
        county: [
          '宛城区',
          '卧龙区',
          '南召县',
          '方城县',
          '西峡县',
          '镇平县',
          '内乡县',
          '淅川县',
          '社旗县',
          '唐河县',
          '新野县',
          '桐柏县',
          '邓州市'
        ]
      },
      {
        name: '商丘市',
        county: [
          '梁园区',
          '睢阳区',
          '民权县',
          '睢县',
          '宁陵县',
          '柘城县',
          '虞城县',
          '夏邑县',
          '永城市'
        ]
      },
      {
        name: '信阳市',
        county: [
          '浉河区',
          '平桥区',
          '罗山县',
          '光山县',
          '新县',
          '商城县',
          '固始县',
          '潢川县',
          '淮滨县',
          '息县'
        ]
      },
      {
        name: '周口市',
        county: [
          '川汇区',
          '扶沟县',
          '西华县',
          '商水县',
          '沈丘县',
          '郸城县',
          '淮阳县',
          '太康县',
          '鹿邑县',
          '项城市'
        ]
      },
      {
        name: '驻马店市',
        county: [
          '驿城区',
          '西平县',
          '上蔡县',
          '平舆县',
          '正阳县',
          '确山县',
          '泌阳县',
          '汝南县',
          '遂平县',
          '新蔡县'
        ]
      },
      {
        name: '省直辖县级行政区划',
        county: [
          '济源市'
        ]
      }
    ]
  },
  {
    name: '湖北省',
    city: [
      {
        name: '武汉市',
        county: [
          '江岸区',
          '江汉区',
          '硚口区',
          '汉阳区',
          '武昌区',
          '青山区',
          '洪山区',
          '东西湖区',
          '汉南区',
          '蔡甸区',
          '江夏区',
          '黄陂区',
          '新洲区'
        ]
      },
      {
        name: '黄石市',
        county: [
          '黄石港区',
          '西塞山区',
          '下陆区',
          '铁山区',
          '阳新县',
          '大冶市'
        ]
      },
      {
        name: '十堰市',
        county: [
          '茅箭区',
          '张湾区',
          '郧阳区',
          '郧西县',
          '竹山县',
          '竹溪县',
          '房县',
          '丹江口市'
        ]
      },
      {
        name: '宜昌市',
        county: [
          '西陵区',
          '伍家岗区',
          '点军区',
          '猇亭区',
          '夷陵区',
          '远安县',
          '兴山县',
          '秭归县',
          '长阳土家族自治县',
          '五峰土家族自治县',
          '宜都市',
          '当阳市',
          '枝江市'
        ]
      },
      {
        name: '襄阳市',
        county: [
          '襄城区',
          '樊城区',
          '襄州区',
          '南漳县',
          '谷城县',
          '保康县',
          '老河口市',
          '枣阳市',
          '宜城市'
        ]
      },
      {
        name: '鄂州市',
        county: [
          '梁子湖区',
          '华容区',
          '鄂城区'
        ]
      },
      {
        name: '荆门市',
        county: [
          '东宝区',
          '掇刀区',
          '京山县',
          '沙洋县',
          '钟祥市'
        ]
      },
      {
        name: '孝感市',
        county: [
          '孝南区',
          '孝昌县',
          '大悟县',
          '云梦县',
          '应城市',
          '安陆市',
          '汉川市'
        ]
      },
      {
        name: '荆州市',
        county: [
          '沙市区',
          '荆州区',
          '公安县',
          '监利县',
          '江陵县',
          '石首市',
          '洪湖市',
          '松滋市'
        ]
      },
      {
        name: '黄冈市',
        county: [
          '黄州区',
          '团风县',
          '红安县',
          '罗田县',
          '英山县',
          '浠水县',
          '蕲春县',
          '黄梅县',
          '麻城市',
          '武穴市'
        ]
      },
      {
        name: '咸宁市',
        county: [
          '咸安区',
          '嘉鱼县',
          '通城县',
          '崇阳县',
          '通山县',
          '赤壁市'
        ]
      },
      {
        name: '随州市',
        county: [
          '曾都区',
          '随县',
          '广水市'
        ]
      },
      {
        name: '恩施土家族苗族自治州',
        county: [
          '恩施市',
          '利川市',
          '建始县',
          '巴东县',
          '宣恩县',
          '咸丰县',
          '来凤县',
          '鹤峰县'
        ]
      },
      {
        name: '省直辖县级行政区划',
        county: [
          '仙桃市',
          '潜江市',
          '天门市',
          '神农架林区'
        ]
      }
    ]
  },
  {
    name: '湖南省',
    city: [
      {
        name: '长沙市',
        county: [
          '芙蓉区',
          '天心区',
          '岳麓区',
          '开福区',
          '雨花区',
          '望城区',
          '长沙县',
          '宁乡县',
          '浏阳市'
        ]
      },
      {
        name: '株洲市',
        county: [
          '荷塘区',
          '芦淞区',
          '石峰区',
          '天元区',
          '株洲县',
          '攸县',
          '茶陵县',
          '炎陵县',
          '醴陵市'
        ]
      },
      {
        name: '湘潭市',
        county: [
          '雨湖区',
          '岳塘区',
          '湘潭县',
          '湘乡市',
          '韶山市'
        ]
      },
      {
        name: '衡阳市',
        county: [
          '珠晖区',
          '雁峰区',
          '石鼓区',
          '蒸湘区',
          '南岳区',
          '衡阳县',
          '衡南县',
          '衡山县',
          '衡东县',
          '祁东县',
          '耒阳市',
          '常宁市'
        ]
      },
      {
        name: '邵阳市',
        county: [
          '双清区',
          '大祥区',
          '北塔区',
          '邵东县',
          '新邵县',
          '邵阳县',
          '隆回县',
          '洞口县',
          '绥宁县',
          '新宁县',
          '城步苗族自治县',
          '武冈市'
        ]
      },
      {
        name: '岳阳市',
        county: [
          '岳阳楼区',
          '云溪区',
          '君山区',
          '岳阳县',
          '华容县',
          '湘阴县',
          '平江县',
          '汨罗市',
          '临湘市'
        ]
      },
      {
        name: '常德市',
        county: [
          '武陵区',
          '鼎城区',
          '安乡县',
          '汉寿县',
          '澧县',
          '临澧县',
          '桃源县',
          '石门县',
          '津市市'
        ]
      },
      {
        name: '张家界市',
        county: [
          '永定区',
          '武陵源区',
          '慈利县',
          '桑植县'
        ]
      },
      {
        name: '益阳市',
        county: [
          '资阳区',
          '赫山区',
          '南县',
          '桃江县',
          '安化县',
          '沅江市'
        ]
      },
      {
        name: '郴州市',
        county: [
          '北湖区',
          '苏仙区',
          '桂阳县',
          '宜章县',
          '永兴县',
          '嘉禾县',
          '临武县',
          '汝城县',
          '桂东县',
          '安仁县',
          '资兴市'
        ]
      },
      {
        name: '永州市',
        county: [
          '零陵区',
          '冷水滩区',
          '祁阳县',
          '东安县',
          '双牌县',
          '道县',
          '江永县',
          '宁远县',
          '蓝山县',
          '新田县',
          '江华瑶族自治县'
        ]
      },
      {
        name: '怀化市',
        county: [
          '鹤城区',
          '中方县',
          '沅陵县',
          '辰溪县',
          '溆浦县',
          '会同县',
          '麻阳苗族自治县',
          '新晃侗族自治县',
          '芷江侗族自治县',
          '靖州苗族侗族自治县',
          '通道侗族自治县',
          '洪江市'
        ]
      },
      {
        name: '娄底市',
        county: [
          '娄星区',
          '双峰县',
          '新化县',
          '冷水江市',
          '涟源市'
        ]
      },
      {
        name: '湘西土家族苗族自治州',
        county: [
          '吉首市',
          '泸溪县',
          '凤凰县',
          '花垣县',
          '保靖县',
          '古丈县',
          '永顺县',
          '龙山县'
        ]
      }
    ]
  },
  {
    name: '广东省',
    city: [
      {
        name: '广州市',
        county: [
          '荔湾区',
          '越秀区',
          '海珠区',
          '天河区',
          '白云区',
          '黄埔区',
          '番禺区',
          '花都区',
          '南沙区',
          '从化区',
          '增城区'
        ]
      },
      {
        name: '韶关市',
        county: [
          '武江区',
          '浈江区',
          '曲江区',
          '始兴县',
          '仁化县',
          '翁源县',
          '乳源瑶族自治县',
          '新丰县',
          '乐昌市',
          '南雄市'
        ]
      },
      {
        name: '深圳市',
        county: [
          '罗湖区',
          '福田区',
          '南山区',
          '宝安区',
          '龙岗区',
          '盐田区'
        ]
      },
      {
        name: '珠海市',
        county: [
          '香洲区',
          '斗门区',
          '金湾区'
        ]
      },
      {
        name: '汕头市',
        county: [
          '龙湖区',
          '金平区',
          '濠江区',
          '潮阳区',
          '潮南区',
          '澄海区',
          '南澳县'
        ]
      },
      {
        name: '佛山市',
        county: [
          '禅城区',
          '南海区',
          '顺德区',
          '三水区',
          '高明区'
        ]
      },
      {
        name: '江门市',
        county: [
          '蓬江区',
          '江海区',
          '新会区',
          '台山市',
          '开平市',
          '鹤山市',
          '恩平市'
        ]
      },
      {
        name: '湛江市',
        county: [
          '赤坎区',
          '霞山区',
          '坡头区',
          '麻章区',
          '遂溪县',
          '徐闻县',
          '廉江市',
          '雷州市',
          '吴川市'
        ]
      },
      {
        name: '茂名市',
        county: [
          '茂南区',
          '电白区',
          '高州市',
          '化州市',
          '信宜市'
        ]
      },
      {
        name: '肇庆市',
        county: [
          '端州区',
          '鼎湖区',
          '高要区',
          '广宁县',
          '怀集县',
          '封开县',
          '德庆县',
          '四会市'
        ]
      },
      {
        name: '惠州市',
        county: [
          '惠城区',
          '惠阳区',
          '博罗县',
          '惠东县',
          '龙门县'
        ]
      },
      {
        name: '梅州市',
        county: [
          '梅江区',
          '梅县区',
          '大埔县',
          '丰顺县',
          '五华县',
          '平远县',
          '蕉岭县',
          '兴宁市'
        ]
      },
      {
        name: '汕尾市',
        county: [
          '城区',
          '海丰县',
          '陆河县',
          '陆丰市'
        ]
      },
      {
        name: '河源市',
        county: [
          '源城区',
          '紫金县',
          '龙川县',
          '连平县',
          '和平县',
          '东源县'
        ]
      },
      {
        name: '阳江市',
        county: [
          '江城区',
          '阳东区',
          '阳西县',
          '阳春市'
        ]
      },
      {
        name: '清远市',
        county: [
          '清城区',
          '清新区',
          '佛冈县',
          '阳山县',
          '连山壮族瑶族自治县',
          '连南瑶族自治县',
          '英德市',
          '连州市'
        ]
      },
      {
        name: '东莞市',
        county: []
      },
      {
        name: '中山市',
        county: []
      },
      {
        name: '潮州市',
        county: [
          '湘桥区',
          '潮安区',
          '饶平县'
        ]
      },
      {
        name: '揭阳市',
        county: [
          '榕城区',
          '揭东区',
          '揭西县',
          '惠来县',
          '普宁市'
        ]
      },
      {
        name: '云浮市',
        county: [
          '云城区',
          '云安区',
          '新兴县',
          '郁南县',
          '罗定市'
        ]
      }
    ]
  },
  {
    name: '广西壮族自治区',
    city: [
      {
        name: '南宁市',
        county: [
          '兴宁区',
          '青秀区',
          '江南区',
          '西乡塘区',
          '良庆区',
          '邕宁区',
          '武鸣区',
          '隆安县',
          '马山县',
          '上林县',
          '宾阳县',
          '横县'
        ]
      },
      {
        name: '柳州市',
        county: [
          '城中区',
          '鱼峰区',
          '柳南区',
          '柳北区',
          '柳江区',
          '柳城县',
          '鹿寨县',
          '融安县',
          '融水苗族自治县',
          '三江侗族自治县'
        ]
      },
      {
        name: '桂林市',
        county: [
          '秀峰区',
          '叠彩区',
          '象山区',
          '七星区',
          '雁山区',
          '临桂区',
          '阳朔县',
          '灵川县',
          '全州县',
          '兴安县',
          '永福县',
          '灌阳县',
          '龙胜各族自治县',
          '资源县',
          '平乐县',
          '荔浦县',
          '恭城瑶族自治县'
        ]
      },
      {
        name: '梧州市',
        county: [
          '万秀区',
          '长洲区',
          '龙圩区',
          '苍梧县',
          '藤县',
          '蒙山县',
          '岑溪市'
        ]
      },
      {
        name: '北海市',
        county: [
          '海城区',
          '银海区',
          '铁山港区',
          '合浦县'
        ]
      },
      {
        name: '防城港市',
        county: [
          '港口区',
          '防城区',
          '上思县',
          '东兴市'
        ]
      },
      {
        name: '钦州市',
        county: [
          '钦南区',
          '钦北区',
          '灵山县',
          '浦北县'
        ]
      },
      {
        name: '贵港市',
        county: [
          '港北区',
          '港南区',
          '覃塘区',
          '平南县',
          '桂平市'
        ]
      },
      {
        name: '玉林市',
        county: [
          '玉州区',
          '福绵区',
          '容县',
          '陆川县',
          '博白县',
          '兴业县',
          '北流市'
        ]
      },
      {
        name: '百色市',
        county: [
          '右江区',
          '田阳县',
          '田东县',
          '平果县',
          '德保县',
          '那坡县',
          '凌云县',
          '乐业县',
          '田林县',
          '西林县',
          '隆林各族自治县',
          '靖西市'
        ]
      },
      {
        name: '贺州市',
        county: [
          '八步区',
          '平桂区',
          '昭平县',
          '钟山县',
          '富川瑶族自治县'
        ]
      },
      {
        name: '河池市',
        county: [
          '金城江区',
          '南丹县',
          '天峨县',
          '凤山县',
          '东兰县',
          '罗城仫佬族自治县',
          '环江毛南族自治县',
          '巴马瑶族自治县',
          '都安瑶族自治县',
          '大化瑶族自治县',
          '宜州市'
        ]
      },
      {
        name: '来宾市',
        county: [
          '兴宾区',
          '忻城县',
          '象州县',
          '武宣县',
          '金秀瑶族自治县',
          '合山市'
        ]
      },
      {
        name: '崇左市',
        county: [
          '江州区',
          '扶绥县',
          '宁明县',
          '龙州县',
          '大新县',
          '天等县',
          '凭祥市'
        ]
      }
    ]
  },
  {
    name: '海南省',
    city: [
      {
        name: '海口市',
        county: [
          '秀英区',
          '龙华区',
          '琼山区',
          '美兰区'
        ]
      },
      {
        name: '三亚市',
        county: [
          '海棠区',
          '吉阳区',
          '天涯区',
          '崖州区'
        ]
      },
      {
        name: '三沙市',
        county: []
      },
      {
        name: '儋州市',
        county: []
      },
      {
        name: '省直辖县级行政区划',
        county: [
          '五指山市',
          '琼海市',
          '文昌市',
          '万宁市',
          '东方市',
          '定安县',
          '屯昌县',
          '澄迈县',
          '临高县',
          '白沙黎族自治县',
          '昌江黎族自治县',
          '乐东黎族自治县',
          '陵水黎族自治县',
          '保亭黎族苗族自治县',
          '琼中黎族苗族自治县'
        ]
      }
    ]
  },
  {
    name: '重庆市',
    city: [
      {
        name: '重庆市',
        county: [
          '万州区',
          '涪陵区',
          '渝中区',
          '大渡口区',
          '江北区',
          '沙坪坝区',
          '九龙坡区',
          '南岸区',
          '北碚区',
          '綦江区',
          '大足区',
          '渝北区',
          '巴南区',
          '黔江区',
          '长寿区',
          '江津区',
          '合川区',
          '永川区',
          '南川区',
          '璧山区',
          '铜梁区',
          '潼南区',
          '荣昌区',
          '开州区'
        ]
      },
      {
        name: '县',
        county: [
          '梁平县',
          '城口县',
          '丰都县',
          '垫江县',
          '武隆县',
          '忠县',
          '云阳县',
          '奉节县',
          '巫山县',
          '巫溪县',
          '石柱土家族自治县',
          '秀山土家族苗族自治县',
          '酉阳土家族苗族自治县',
          '彭水苗族土家族自治县'
        ]
      }
    ]
  },
  {
    name: '四川省',
    city: [
      {
        name: '成都市',
        county: [
          '锦江区',
          '青羊区',
          '金牛区',
          '武侯区',
          '成华区',
          '龙泉驿区',
          '青白江区',
          '新都区',
          '温江区',
          '双流区',
          '金堂县',
          '郫县',
          '大邑县',
          '蒲江县',
          '新津县',
          '都江堰市',
          '彭州市',
          '邛崃市',
          '崇州市',
          '简阳市'
        ]
      },
      {
        name: '自贡市',
        county: [
          '自流井区',
          '贡井区',
          '大安区',
          '沿滩区',
          '荣县',
          '富顺县'
        ]
      },
      {
        name: '攀枝花市',
        county: [
          '东区',
          '西区',
          '仁和区',
          '米易县',
          '盐边县'
        ]
      },
      {
        name: '泸州市',
        county: [
          '江阳区',
          '纳溪区',
          '龙马潭区',
          '泸县',
          '合江县',
          '叙永县',
          '古蔺县'
        ]
      },
      {
        name: '德阳市',
        county: [
          '旌阳区',
          '中江县',
          '罗江县',
          '广汉市',
          '什邡市',
          '绵竹市'
        ]
      },
      {
        name: '绵阳市',
        county: [
          '涪城区',
          '游仙区',
          '安州区',
          '三台县',
          '盐亭县',
          '梓潼县',
          '北川羌族自治县',
          '平武县',
          '江油市'
        ]
      },
      {
        name: '广元市',
        county: [
          '利州区',
          '昭化区',
          '朝天区',
          '旺苍县',
          '青川县',
          '剑阁县',
          '苍溪县'
        ]
      },
      {
        name: '遂宁市',
        county: [
          '船山区',
          '安居区',
          '蓬溪县',
          '射洪县',
          '大英县'
        ]
      },
      {
        name: '内江市',
        county: [
          '市中区',
          '东兴区',
          '威远县',
          '资中县',
          '隆昌县'
        ]
      },
      {
        name: '乐山市',
        county: [
          '市中区',
          '沙湾区',
          '五通桥区',
          '金口河区',
          '犍为县',
          '井研县',
          '夹江县',
          '沐川县',
          '峨边彝族自治县',
          '马边彝族自治县',
          '峨眉山市'
        ]
      },
      {
        name: '南充市',
        county: [
          '顺庆区',
          '高坪区',
          '嘉陵区',
          '南部县',
          '营山县',
          '蓬安县',
          '仪陇县',
          '西充县',
          '阆中市'
        ]
      },
      {
        name: '眉山市',
        county: [
          '东坡区',
          '彭山区',
          '仁寿县',
          '洪雅县',
          '丹棱县',
          '青神县'
        ]
      },
      {
        name: '宜宾市',
        county: [
          '翠屏区',
          '南溪区',
          '宜宾县',
          '江安县',
          '长宁县',
          '高县',
          '珙县',
          '筠连县',
          '兴文县',
          '屏山县'
        ]
      },
      {
        name: '广安市',
        county: [
          '广安区',
          '前锋区',
          '岳池县',
          '武胜县',
          '邻水县',
          '华蓥市'
        ]
      },
      {
        name: '达州市',
        county: [
          '通川区',
          '达川区',
          '宣汉县',
          '开江县',
          '大竹县',
          '渠县',
          '万源市'
        ]
      },
      {
        name: '雅安市',
        county: [
          '雨城区',
          '名山区',
          '荥经县',
          '汉源县',
          '石棉县',
          '天全县',
          '芦山县',
          '宝兴县'
        ]
      },
      {
        name: '巴中市',
        county: [
          '巴州区',
          '恩阳区',
          '通江县',
          '南江县',
          '平昌县'
        ]
      },
      {
        name: '资阳市',
        county: [
          '雁江区',
          '安岳县',
          '乐至县'
        ]
      },
      {
        name: '阿坝藏族羌族自治州',
        county: [
          '马尔康市',
          '汶川县',
          '理县',
          '茂县',
          '松潘县',
          '九寨沟县',
          '金川县',
          '小金县',
          '黑水县',
          '壤塘县',
          '阿坝县',
          '若尔盖县',
          '红原县'
        ]
      },
      {
        name: '甘孜藏族自治州',
        county: [
          '康定市',
          '泸定县',
          '丹巴县',
          '九龙县',
          '雅江县',
          '道孚县',
          '炉霍县',
          '甘孜县',
          '新龙县',
          '德格县',
          '白玉县',
          '石渠县',
          '色达县',
          '理塘县',
          '巴塘县',
          '乡城县',
          '稻城县',
          '得荣县'
        ]
      },
      {
        name: '凉山彝族自治州',
        county: [
          '西昌市',
          '木里藏族自治县',
          '盐源县',
          '德昌县',
          '会理县',
          '会东县',
          '宁南县',
          '普格县',
          '布拖县',
          '金阳县',
          '昭觉县',
          '喜德县',
          '冕宁县',
          '越西县',
          '甘洛县',
          '美姑县',
          '雷波县'
        ]
      }
    ]
  },
  {
    name: '贵州省',
    city: [
      {
        name: '贵阳市',
        county: [
          '南明区',
          '云岩区',
          '花溪区',
          '乌当区',
          '白云区',
          '观山湖区',
          '开阳县',
          '息烽县',
          '修文县',
          '清镇市'
        ]
      },
      {
        name: '六盘水市',
        county: [
          '钟山区',
          '六枝特区',
          '水城县',
          '盘县'
        ]
      },
      {
        name: '遵义市',
        county: [
          '红花岗区',
          '汇川区',
          '播州区',
          '桐梓县',
          '绥阳县',
          '正安县',
          '道真仡佬族苗族自治县',
          '务川仡佬族苗族自治县',
          '凤冈县',
          '湄潭县',
          '余庆县',
          '习水县',
          '赤水市',
          '仁怀市'
        ]
      },
      {
        name: '安顺市',
        county: [
          '西秀区',
          '平坝区',
          '普定县',
          '镇宁布依族苗族自治县',
          '关岭布依族苗族自治县',
          '紫云苗族布依族自治县'
        ]
      },
      {
        name: '毕节市',
        county: [
          '七星关区',
          '大方县',
          '黔西县',
          '金沙县',
          '织金县',
          '纳雍县',
          '威宁彝族回族苗族自治县',
          '赫章县'
        ]
      },
      {
        name: '铜仁市',
        county: [
          '碧江区',
          '万山区',
          '江口县',
          '玉屏侗族自治县',
          '石阡县',
          '思南县',
          '印江土家族苗族自治县',
          '德江县',
          '沿河土家族自治县',
          '松桃苗族自治县'
        ]
      },
      {
        name: '黔西南布依族苗族自治州',
        county: [
          '兴义市',
          '兴仁县',
          '普安县',
          '晴隆县',
          '贞丰县',
          '望谟县',
          '册亨县',
          '安龙县'
        ]
      },
      {
        name: '黔东南苗族侗族自治州',
        county: [
          '凯里市',
          '黄平县',
          '施秉县',
          '三穗县',
          '镇远县',
          '岑巩县',
          '天柱县',
          '锦屏县',
          '剑河县',
          '台江县',
          '黎平县',
          '榕江县',
          '从江县',
          '雷山县',
          '麻江县',
          '丹寨县'
        ]
      },
      {
        name: '黔南布依族苗族自治州',
        county: [
          '都匀市',
          '福泉市',
          '荔波县',
          '贵定县',
          '瓮安县',
          '独山县',
          '平塘县',
          '罗甸县',
          '长顺县',
          '龙里县',
          '惠水县',
          '三都水族自治县'
        ]
      }
    ]
  },
  {
    name: '云南省',
    city: [
      {
        name: '昆明市',
        county: [
          '五华区',
          '盘龙区',
          '官渡区',
          '西山区',
          '东川区',
          '呈贡区',
          '晋宁县',
          '富民县',
          '宜良县',
          '石林彝族自治县',
          '嵩明县',
          '禄劝彝族苗族自治县',
          '寻甸回族彝族自治县',
          '安宁市'
        ]
      },
      {
        name: '曲靖市',
        county: [
          '麒麟区',
          '沾益区',
          '马龙县',
          '陆良县',
          '师宗县',
          '罗平县',
          '富源县',
          '会泽县',
          '宣威市'
        ]
      },
      {
        name: '玉溪市',
        county: [
          '红塔区',
          '江川区',
          '澄江县',
          '通海县',
          '华宁县',
          '易门县',
          '峨山彝族自治县',
          '新平彝族傣族自治县',
          '元江哈尼族彝族傣族自治县'
        ]
      },
      {
        name: '保山市',
        county: [
          '隆阳区',
          '施甸县',
          '龙陵县',
          '昌宁县',
          '腾冲市'
        ]
      },
      {
        name: '昭通市',
        county: [
          '昭阳区',
          '鲁甸县',
          '巧家县',
          '盐津县',
          '大关县',
          '永善县',
          '绥江县',
          '镇雄县',
          '彝良县',
          '威信县',
          '水富县'
        ]
      },
      {
        name: '丽江市',
        county: [
          '古城区',
          '玉龙纳西族自治县',
          '永胜县',
          '华坪县',
          '宁蒗彝族自治县'
        ]
      },
      {
        name: '普洱市',
        county: [
          '思茅区',
          '宁洱哈尼族彝族自治县',
          '墨江哈尼族自治县',
          '景东彝族自治县',
          '景谷傣族彝族自治县',
          '镇沅彝族哈尼族拉祜族自治县',
          '江城哈尼族彝族自治县',
          '孟连傣族拉祜族佤族自治县',
          '澜沧拉祜族自治县',
          '西盟佤族自治县'
        ]
      },
      {
        name: '临沧市',
        county: [
          '临翔区',
          '凤庆县',
          '云县',
          '永德县',
          '镇康县',
          '双江拉祜族佤族布朗族傣族自治县',
          '耿马傣族佤族自治县',
          '沧源佤族自治县'
        ]
      },
      {
        name: '楚雄彝族自治州',
        county: [
          '楚雄市',
          '双柏县',
          '牟定县',
          '南华县',
          '姚安县',
          '大姚县',
          '永仁县',
          '元谋县',
          '武定县',
          '禄丰县'
        ]
      },
      {
        name: '红河哈尼族彝族自治州',
        county: [
          '个旧市',
          '开远市',
          '蒙自市',
          '弥勒市',
          '屏边苗族自治县',
          '建水县',
          '石屏县',
          '泸西县',
          '元阳县',
          '红河县',
          '金平苗族瑶族傣族自治县',
          '绿春县',
          '河口瑶族自治县'
        ]
      },
      {
        name: '文山壮族苗族自治州',
        county: [
          '文山市',
          '砚山县',
          '西畴县',
          '麻栗坡县',
          '马关县',
          '丘北县',
          '广南县',
          '富宁县'
        ]
      },
      {
        name: '西双版纳傣族自治州',
        county: [
          '景洪市',
          '勐海县',
          '勐腊县'
        ]
      },
      {
        name: '大理白族自治州',
        county: [
          '大理市',
          '漾濞彝族自治县',
          '祥云县',
          '宾川县',
          '弥渡县',
          '南涧彝族自治县',
          '巍山彝族回族自治县',
          '永平县',
          '云龙县',
          '洱源县',
          '剑川县',
          '鹤庆县'
        ]
      },
      {
        name: '德宏傣族景颇族自治州',
        county: [
          '瑞丽市',
          '芒市',
          '梁河县',
          '盈江县',
          '陇川县'
        ]
      },
      {
        name: '怒江傈僳族自治州',
        county: [
          '泸水市',
          '福贡县',
          '贡山独龙族怒族自治县',
          '兰坪白族普米族自治县'
        ]
      },
      {
        name: '迪庆藏族自治州',
        county: [
          '香格里拉市',
          '德钦县',
          '维西傈僳族自治县'
        ]
      }
    ]
  },
  {
    name: '西藏自治区',
    city: [
      {
        name: '拉萨市',
        county: [
          '城关区',
          '堆龙德庆区',
          '林周县',
          '当雄县',
          '尼木县',
          '曲水县',
          '达孜县',
          '墨竹工卡县'
        ]
      },
      {
        name: '日喀则市',
        county: [
          '桑珠孜区',
          '南木林县',
          '江孜县',
          '定日县',
          '萨迦县',
          '拉孜县',
          '昂仁县',
          '谢通门县',
          '白朗县',
          '仁布县',
          '康马县',
          '定结县',
          '仲巴县',
          '亚东县',
          '吉隆县',
          '聂拉木县',
          '萨嘎县',
          '岗巴县'
        ]
      },
      {
        name: '昌都市',
        county: [
          '卡若区',
          '江达县',
          '贡觉县',
          '类乌齐县',
          '丁青县',
          '察雅县',
          '八宿县',
          '左贡县',
          '芒康县',
          '洛隆县',
          '边坝县'
        ]
      },
      {
        name: '林芝市',
        county: [
          '巴宜区',
          '工布江达县',
          '米林县',
          '墨脱县',
          '波密县',
          '察隅县',
          '朗县'
        ]
      },
      {
        name: '山南市',
        county: [
          '乃东区',
          '扎囊县',
          '贡嘎县',
          '桑日县',
          '琼结县',
          '曲松县',
          '措美县',
          '洛扎县',
          '加查县',
          '隆子县',
          '错那县',
          '浪卡子县'
        ]
      },
      {
        name: '那曲地区',
        county: [
          '那曲县',
          '嘉黎县',
          '比如县',
          '聂荣县',
          '安多县',
          '申扎县',
          '索县',
          '班戈县',
          '巴青县',
          '尼玛县',
          '双湖县'
        ]
      },
      {
        name: '阿里地区',
        county: [
          '普兰县',
          '札达县',
          '噶尔县',
          '日土县',
          '革吉县',
          '改则县',
          '措勤县'
        ]
      }
    ]
  },
  {
    name: '陕西省',
    city: [
      {
        name: '西安市',
        county: [
          '新城区',
          '碑林区',
          '莲湖区',
          '灞桥区',
          '未央区',
          '雁塔区',
          '阎良区',
          '临潼区',
          '长安区',
          '高陵区',
          '蓝田县',
          '周至县',
          '户县'
        ]
      },
      {
        name: '铜川市',
        county: [
          '王益区',
          '印台区',
          '耀州区',
          '宜君县'
        ]
      },
      {
        name: '宝鸡市',
        county: [
          '渭滨区',
          '金台区',
          '陈仓区',
          '凤翔县',
          '岐山县',
          '扶风县',
          '眉县',
          '陇县',
          '千阳县',
          '麟游县',
          '凤县',
          '太白县'
        ]
      },
      {
        name: '咸阳市',
        county: [
          '秦都区',
          '杨陵区',
          '渭城区',
          '三原县',
          '泾阳县',
          '乾县',
          '礼泉县',
          '永寿县',
          '彬县',
          '长武县',
          '旬邑县',
          '淳化县',
          '武功县',
          '兴平市'
        ]
      },
      {
        name: '渭南市',
        county: [
          '临渭区',
          '华州区',
          '潼关县',
          '大荔县',
          '合阳县',
          '澄城县',
          '蒲城县',
          '白水县',
          '富平县',
          '韩城市',
          '华阴市'
        ]
      },
      {
        name: '延安市',
        county: [
          '宝塔区',
          '安塞区',
          '延长县',
          '延川县',
          '子长县',
          '志丹县',
          '吴起县',
          '甘泉县',
          '富县',
          '洛川县',
          '宜川县',
          '黄龙县',
          '黄陵县'
        ]
      },
      {
        name: '汉中市',
        county: [
          '汉台区',
          '南郑县',
          '城固县',
          '洋县',
          '西乡县',
          '勉县',
          '宁强县',
          '略阳县',
          '镇巴县',
          '留坝县',
          '佛坪县'
        ]
      },
      {
        name: '榆林市',
        county: [
          '榆阳区',
          '横山区',
          '神木县',
          '府谷县',
          '靖边县',
          '定边县',
          '绥德县',
          '米脂县',
          '佳县',
          '吴堡县',
          '清涧县',
          '子洲县'
        ]
      },
      {
        name: '安康市',
        county: [
          '汉滨区',
          '汉阴县',
          '石泉县',
          '宁陕县',
          '紫阳县',
          '岚皋县',
          '平利县',
          '镇坪县',
          '旬阳县',
          '白河县'
        ]
      },
      {
        name: '商洛市',
        county: [
          '商州区',
          '洛南县',
          '丹凤县',
          '商南县',
          '山阳县',
          '镇安县',
          '柞水县'
        ]
      }
    ]
  },
  {
    name: '甘肃省',
    city: [
      {
        name: '兰州市',
        county: [
          '城关区',
          '七里河区',
          '西固区',
          '安宁区',
          '红古区',
          '永登县',
          '皋兰县',
          '榆中县'
        ]
      },
      {
        name: '嘉峪关市',
        county: [
          '嘉峪关市'
        ]
      },
      {
        name: '金昌市',
        county: [
          '金川区',
          '永昌县'
        ]
      },
      {
        name: '白银市',
        county: [
          '白银区',
          '平川区',
          '靖远县',
          '会宁县',
          '景泰县'
        ]
      },
      {
        name: '天水市',
        county: [
          '秦州区',
          '麦积区',
          '清水县',
          '秦安县',
          '甘谷县',
          '武山县',
          '张家川回族自治县'
        ]
      },
      {
        name: '武威市',
        county: [
          '凉州区',
          '民勤县',
          '古浪县',
          '天祝藏族自治县'
        ]
      },
      {
        name: '张掖市',
        county: [
          '甘州区',
          '肃南裕固族自治县',
          '民乐县',
          '临泽县',
          '高台县',
          '山丹县'
        ]
      },
      {
        name: '平凉市',
        county: [
          '崆峒区',
          '泾川县',
          '灵台县',
          '崇信县',
          '华亭县',
          '庄浪县',
          '静宁县'
        ]
      },
      {
        name: '酒泉市',
        county: [
          '肃州区',
          '金塔县',
          '瓜州县',
          '肃北蒙古族自治县',
          '阿克塞哈萨克族自治县',
          '玉门市',
          '敦煌市'
        ]
      },
      {
        name: '庆阳市',
        county: [
          '西峰区',
          '庆城县',
          '环县',
          '华池县',
          '合水县',
          '正宁县',
          '宁县',
          '镇原县'
        ]
      },
      {
        name: '定西市',
        county: [
          '安定区',
          '通渭县',
          '陇西县',
          '渭源县',
          '临洮县',
          '漳县',
          '岷县'
        ]
      },
      {
        name: '陇南市',
        county: [
          '武都区',
          '成县',
          '文县',
          '宕昌县',
          '康县',
          '西和县',
          '礼县',
          '徽县',
          '两当县'
        ]
      },
      {
        name: '临夏回族自治州',
        county: [
          '临夏市',
          '临夏县',
          '康乐县',
          '永靖县',
          '广河县',
          '和政县',
          '东乡族自治县',
          '积石山保安族东乡族撒拉族自治县'
        ]
      },
      {
        name: '甘南藏族自治州',
        county: [
          '合作市',
          '临潭县',
          '卓尼县',
          '舟曲县',
          '迭部县',
          '玛曲县',
          '碌曲县',
          '夏河县'
        ]
      }
    ]
  },
  {
    name: '青海省',
    city: [
      {
        name: '西宁市',
        county: [
          '城东区',
          '城中区',
          '城西区',
          '城北区',
          '大通回族土族自治县',
          '湟中县',
          '湟源县'
        ]
      },
      {
        name: '海东市',
        county: [
          '乐都区',
          '平安区',
          '民和回族土族自治县',
          '互助土族自治县',
          '化隆回族自治县',
          '循化撒拉族自治县'
        ]
      },
      {
        name: '海北藏族自治州',
        county: [
          '门源回族自治县',
          '祁连县',
          '海晏县',
          '刚察县'
        ]
      },
      {
        name: '黄南藏族自治州',
        county: [
          '同仁县',
          '尖扎县',
          '泽库县',
          '河南蒙古族自治县'
        ]
      },
      {
        name: '海南藏族自治州',
        county: [
          '共和县',
          '同德县',
          '贵德县',
          '兴海县',
          '贵南县'
        ]
      },
      {
        name: '果洛藏族自治州',
        county: [
          '玛沁县',
          '班玛县',
          '甘德县',
          '达日县',
          '久治县',
          '玛多县'
        ]
      },
      {
        name: '玉树藏族自治州',
        county: [
          '玉树市',
          '杂多县',
          '称多县',
          '治多县',
          '囊谦县',
          '曲麻莱县'
        ]
      },
      {
        name: '海西蒙古族藏族自治州',
        county: [
          '格尔木市',
          '德令哈市',
          '乌兰县',
          '都兰县',
          '天峻县'
        ]
      }
    ]
  },
  {
    name: '宁夏回族自治区',
    city: [
      {
        name: '银川市',
        county: [
          '兴庆区',
          '西夏区',
          '金凤区',
          '永宁县',
          '贺兰县',
          '灵武市'
        ]
      },
      {
        name: '石嘴山市',
        county: [
          '大武口区',
          '惠农区',
          '平罗县'
        ]
      },
      {
        name: '吴忠市',
        county: [
          '利通区',
          '红寺堡区',
          '盐池县',
          '同心县',
          '青铜峡市'
        ]
      },
      {
        name: '固原市',
        county: [
          '原州区',
          '西吉县',
          '隆德县',
          '泾源县',
          '彭阳县'
        ]
      },
      {
        name: '中卫市',
        county: [
          '沙坡头区',
          '中宁县',
          '海原县'
        ]
      }
    ]
  },
  {
    name: '新疆维吾尔自治区',
    city: [
      {
        name: '乌鲁木齐市',
        county: [
          '天山区',
          '沙依巴克区',
          '新市区',
          '水磨沟区',
          '头屯河区',
          '达坂城区',
          '米东区',
          '乌鲁木齐县'
        ]
      },
      {
        name: '克拉玛依市',
        county: [
          '独山子区',
          '克拉玛依区',
          '白碱滩区',
          '乌尔禾区'
        ]
      },
      {
        name: '吐鲁番市',
        county: [
          '高昌区',
          '鄯善县',
          '托克逊县'
        ]
      },
      {
        name: '哈密市',
        county: [
          '伊州区',
          '巴里坤哈萨克自治县',
          '伊吾县'
        ]
      },
      {
        name: '昌吉回族自治州',
        county: [
          '昌吉市',
          '阜康市',
          '呼图壁县',
          '玛纳斯县',
          '奇台县',
          '吉木萨尔县',
          '木垒哈萨克自治县'
        ]
      },
      {
        name: '博尔塔拉蒙古自治州',
        county: [
          '博乐市',
          '阿拉山口市',
          '精河县',
          '温泉县'
        ]
      },
      {
        name: '巴音郭楞蒙古自治州',
        county: [
          '库尔勒市',
          '轮台县',
          '尉犁县',
          '若羌县',
          '且末县',
          '焉耆回族自治县',
          '和静县',
          '和硕县',
          '博湖县'
        ]
      },
      {
        name: '阿克苏地区',
        county: [
          '阿克苏市',
          '温宿县',
          '库车县',
          '沙雅县',
          '新和县',
          '拜城县',
          '乌什县',
          '阿瓦提县',
          '柯坪县'
        ]
      },
      {
        name: '克孜勒苏柯尔克孜自治州',
        county: [
          '阿图什市',
          '阿克陶县',
          '阿合奇县',
          '乌恰县'
        ]
      },
      {
        name: '喀什地区',
        county: [
          '喀什市',
          '疏附县',
          '疏勒县',
          '英吉沙县',
          '泽普县',
          '莎车县',
          '叶城县',
          '麦盖提县',
          '岳普湖县',
          '伽师县',
          '巴楚县',
          '塔什库尔干塔吉克自治县'
        ]
      },
      {
        name: '和田地区',
        county: [
          '和田市',
          '和田县',
          '墨玉县',
          '皮山县',
          '洛浦县',
          '策勒县',
          '于田县',
          '民丰县'
        ]
      },
      {
        name: '伊犁哈萨克自治州',
        county: [
          '伊宁市',
          '奎屯市',
          '霍尔果斯市',
          '伊宁县',
          '察布查尔锡伯自治县',
          '霍城县',
          '巩留县',
          '新源县',
          '昭苏县',
          '特克斯县',
          '尼勒克县'
        ]
      },
      {
        name: '塔城地区',
        county: [
          '塔城市',
          '乌苏市',
          '额敏县',
          '沙湾县',
          '托里县',
          '裕民县',
          '和布克赛尔蒙古自治县'
        ]
      },
      {
        name: '阿勒泰地区',
        county: [
          '阿勒泰市',
          '布尔津县',
          '富蕴县',
          '福海县',
          '哈巴河县',
          '青河县',
          '吉木乃县'
        ]
      },
      {
        name: '自治区直辖县级行政区划',
        county: [
          '石河子市',
          '阿拉尔市',
          '图木舒克市',
          '五家渠市',
          '铁门关市'
        ]
      }
    ]
  },
  {
    name: '台湾省',
    city: []
  },
  {
    name: '香港特别行政区',
    city: []
  },
  {
    name: '澳门特别行政区',
    city: []
  }
]

export const box07Tab = [
  {
    title: '重要农产品安全保障',
    children: [
      {
        title: '粮食安全',
        children: [
          { code: '57270341-8eeb-4bed-8004-0cb6e0b65294', title: '粮食安全政治责任' },
          { code: '35ee0b60-66b3-42fa-ae40-316dd5e54081', title: '粮食安全战略' },
          { code: '55b37ff2-45f1-4625-baf5-8758d3712696', title: '粮食品种结构优化' },
          { code: '75616e94-6b76-46f6-a77c-060473b92909', title: '粮食生产数据' }
        ]
      },
      {
        title: '耕地保护',
        children: [
          { code: 'f44275ef-2418-4b38-a648-c48ae8dffaa0', title: '耕地保护制度' },
          { code: '699e4e5f-edcd-427e-9f42-f016e9f00fe9', title: '耕地保护与利用' },
          { code: '86effc0e-ce9f-49a9-a50f-e7203aca0b7c', title: '黑土地保护' },
          { code: 'c02be232-0850-4ad6-acba-9e6c05df2ae7', title: '提升耕地地力' }
        ]
      },
      {
        title: '绿色农业',
        children: [
          { code: '4e75952f-d528-426e-a99a-f57b199ccb51', title: '农业绿色生产' },
          { code: '024eecd5-e37c-4828-9b6d-4a97b13edbfc', title: '农业废弃物利用' },
          { code: 'fa55a825-9558-4d1e-bb43-16740ee59593', title: '农业生态系统' },
          { code: '69b5abd4-df13-47f6-b7b2-ade9032743ce', title: '长江“十年禁渔”' }
        ]
      },
      {
        title: '农产品质量安全',
        children: [
          { code: '382f1f46-54cd-49c8-855d-94caef9de4c0', title: '标准化生产' },
          { code: 'c8f2550f-2bb4-42b2-b1bc-3f665c703754', title: '安全绿色优质农产品' },
          { code: '3c991710-734c-419f-b8c1-1ed0c88bf95e', title: '农产品质量安全风险防范' }
        ]
      },
      {
        title: '农业风险防控',
        children: [
          { code: 'f2dce1b3-652d-4eba-b9af-024301590f72', title: '农业防灾减灾' },
          { code: '5f4c1ae2-50b2-4975-827e-cd9015dcbb25', title: '农产品市场调控' },
          { code: 'c7d4bc5e-bf9b-4d9e-823e-daf32f5aef24', title: '国际农产品供应链' },
          { code: '0be26310-f873-4a8e-95f3-2b4b49c7d8ae', title: '农业生产安全' }
        ]
      },
      {
        title: '粮食等重要农产品安全保障工程',
        children: [
          { code: '1a9795c3-6a2a-4fc3-9381-237d9b92848c', title: '高标准农田建设' },
          { code: '64a378b3-54b6-4b33-a3b9-dede872fb319', title: '国家粮食安全产业带建设' },
          { code: 'b1e6fafd-8914-4d87-8cf7-7f48c10690a9', title: '优质粮食工程' },
          { code: '59d577d3-2c46-4d60-b878-19a0b95decd5', title: '棉油糖胶生产能力建设' },
          { code: '3114551f-6755-4ba3-816e-ab4ccb3547f0', title: '绿色高质高效行动' },
          { code: '29670de3-8520-4698-bb8a-ca3932993f65', title: '动物防疫和农作物病虫害防治' },
          { code: '61acf1f6-d316-4e6d-bd76-dc5501eb5c7c', title: '生猪标准化养殖' },
          { code: 'cd6489ef-d7c4-4c05-85f1-eee27eec8450', title: '草食畜牧业提升' },
          { code: '39b9cf28-a1de-4115-90b8-5d53a5fc3c87', title: '水产养殖转型升级' },
          { code: '4a087b4c-3c1d-44af-8c19-7c51c16c373c', title: '渔船更新改造和渔港建设' }
        ]
      }
    ]
  },
  {
    title: '农业科技创新',
    children: [
      {
        title: '现代农业科技支撑',
        children: [
          { code: '04146876-37ce-45d4-850c-98ea12d00dfb', title: '农业关键核心技术' },
          { code: 'ed423326-f5cc-40e9-913b-f452f5b244d5', title: '农业科技与产业全产业链融合模式' },
          { code: '9a740397-729d-4f78-ad04-c5e46f7c4534', title: '农业科技与产业技术主导融合模式' },
          { code: 'f4f78060-3806-4f74-8736-ad3a1ba47389', title: '农业科技与产业集聚融合模式' },
          { code: 'dc2d2170-d8b6-44d7-9103-95897ff5281f', title: '农业科技与循环型产业融合模式' },
          { code: '41d801c8-3ec1-4fbe-9a6e-b63705ead044', title: '农业科技与产业链延伸融合模式' },
          { code: '2001e90d-bd32-470b-bd94-f8f9744425e8', title: '农业科技与产城融合模式' }
        ]
      },
      {
        title: '种业振兴',
        children: [
          { code: '2f960954-9d09-4573-b713-0455b918905d', title: '种质资源保护' },
          { code: '265fc4fb-9875-4ecc-a976-3e645a396ed0', title: '育种创新攻关' },
          { code: '5220fb6a-2098-444a-b01f-3ce243b69dfc', title: '种业基地建设' },
          { code: 'f3db4beb-0581-487d-9983-4334be52af80', title: '种业市场监管' }
        ]
      },
      {
        title: '农业机械化',
        children: [
          { code: '62d4bb34-8126-4821-ada8-f595b8796a16', title: '农机装备产业' },
          { code: '352180b6-d669-4974-84b9-03179dd14a61', title: '农机装备研发' },
          { code: '3d3ba152-d179-43ed-8236-9e4a7c364cec', title: '农机装备应用' },
          { code: 'd904fc88-788c-477a-a2f0-e609002c9132', title: '农业机械化' }
        ]
      },
      {
        title: '农业信息化',
        children: [
          { code: '50121a20-592e-4c98-b68e-65d01c5dcfc2', title: '农业农村大数据' },
          { code: 'd76ac7e1-641a-4783-85c0-502f87662896', title: '农业生产智能化' },
          { code: 'eeb83f01-bed9-453d-bb08-114b51d6b9b5', title: '农业信息服务体系' }
        ]
      },
      {
        title: '农业质量效益和竞争力提升工程',
        children: [
          { code: '2541cb1b-3fcf-4107-bea6-f65d2d2c21b2', title: '农业科技创新能力建设' },
          { code: '0376bc19-1c08-4d90-b886-31b85d787a99', title: '基层农技推广体系建设' },
          { code: '27d4a853-8616-4f9b-9c0f-b634b587aa68', title: '现代种业' },
          { code: '33b03cec-9558-4456-a321-ae939931afd8', title: '新型农业经营主体培育提升行动' },
          { code: 'b42e8618-389b-468d-a3fa-dbd0cdde129a', title: '农业生产“三品一标”提升行动' }
        ]
      }
    ]
  },
  {
    title: '现代乡村产业体系',
    children: [
      {
        title: '乡村产业布局',
        children: [
          { code: '66dcc36e-32da-4c8c-b7ce-ce42da3637c8', title: '种植业养殖业' },
          { code: '583a69c5-fe0b-4659-984a-3a782b106926', title: '农产品加工业' },
          { code: '29eea950-e4ea-4c73-9aea-e1d3d8bead53', title: '乡村休闲旅游业' },
          { code: '6f49d762-6f29-4b6c-b956-c7a90e303622', title: '乡村新型服务业' },
          { code: '5587a5fd-0f54-401d-a8b4-597c03d0e7ee', title: '农村电子商务' }
        ]
      },
      {
        title: '现代农业产业体系',
        children: [
          { code: '85883b44-1d91-43b9-8e0c-5339793df91d', title: '农业产业链' },
          { code: '1f279b94-552d-4c4f-8901-873a432702ba', title: '产业化龙头企业' },
          { code: '8a249649-4023-4dc0-b7ca-db167f8f97a9', title: '知名农业品牌' }
        ]
      },
      {
        title: '现代农业经营体系',
        children: [
          { code: 'aa7bddfd-0fe7-4b2a-b78b-8dd602605d01', title: '农民合作社和家庭农场' },
          { code: '3c50120f-1101-455f-990f-d5f71927a114', title: '社会化服务体系' },
          { code: '101dcf81-8755-4168-9417-1852438da249', title: '利益联结机制' }
        ]
      },
      {
        title: '农村一二三产业融合',
        children: [
          { code: 'f7c99469-6910-4ec4-9cf0-1012409613e0', title: '“农业+”业态融合' },
          { code: '17160c58-af1f-486c-9495-97d294cf6329', title: '现代农业产业园区' },
          { code: '0e4ee542-eac3-4cde-a791-b363bd08930f', title: '农业现代化示范区' },
          { code: 'feb505d5-aeb5-4a3f-ab93-4cfeefa0ed61', title: '农产品冷链物流设施' }
        ]
      },
      {
        title: '农村创业创新',
        children: [
          { code: 'bb40036a-65f9-4d82-8b49-1d28ac2e1504', title: '返乡入乡创业' },
          { code: 'b5acadb7-7af0-493f-9927-9da8eec2980b', title: '创业创新孵化载体' },
          { code: 'f679d113-7969-4ce0-b815-3cdb99675412', title: '创业创新培训' },
          { code: '0fded761-c874-44e1-a3b5-d999bf9b18e9', title: '带头人培育行动' }
        ]
      }
    ]
  },
  {
    title: '乡村建设行动',
    children: [
      {
        title: '乡村规划',
        children: [
          { code: 'cbdce981-4758-4dd4-9fbf-f0cc706d2cdf', title: '县域布局' },
          { code: '38de1911-9715-4bce-9683-d10bf4981dc0', title: '村庄规划' }
        ]
      },
      {
        title: '农村人居环境',
        children: [
          { code: '8ee4cf03-5521-4602-88d2-504643fd4d4a', title: '农村厕所革命' },
          { code: '2d86d49c-583a-40b8-b1a7-9c72bd817374', title: '农村生活污水治理' },
          { code: '2ff20cdd-2cfe-4381-aeb4-3a058cc8522c', title: '农村生活垃圾处理' },
          { code: 'e49d38a7-c6a4-411d-9c07-d0f970086e53', title: '村容村貌' }
        ]
      },
      {
        title: '数字乡村建设',
        children: [
          { code: 'e0ea658a-1408-4fc0-be11-3f9640e575bc', title: '农村信息基础设施' },
          { code: '43876cdd-b908-43e0-918e-8b824a476e58', title: '智慧农业' },
          { code: 'bee63501-8923-46c7-b7c1-6e95e589bed7', title: '乡村管理服务数字化' }
        ]
      },
      {
        title: '城乡基本公共服务',
        children: [
          { code: 'c2d49cac-17d0-4148-a099-b05a56515829', title: '农村教育' },
          { code: 'd4eb3c77-ac85-4426-a707-d16522cd1f39', title: '健康乡村' },
          { code: 'abeada70-9738-4156-a008-5ba376d22e95', title: '农村养老服务' },
          { code: 'ce081fcb-6ec4-4a91-a440-0c13904cd82b', title: '村级综合服务' }
        ]
      },
      {
        title: '农村消费',
        children: [
          { code: '601326e5-21b4-4107-bd01-5bd994cb0603', title: '增收渠道建设' },
          { code: '79305605-0d96-4e65-b3c6-34eb44e371b0', title: '农村消费促进行动' },
          { code: '8093c083-4b55-4f6e-a69c-1929a230ba59', title: '农村消费环境优化' }
        ]
      },
      {
        title: '乡村公共基础设施建设工程',
        children: [
          { code: '03bfb358-5085-44b8-9a87-11c06cdb9ff9', title: '农村道路畅通' },
          { code: 'ddd575bd-12f6-4cc1-8715-11c26a911dec', title: '农村供水保障' },
          { code: '2006fb08-3447-41e0-a884-e625997f27ed', title: '乡村清洁能源建设' },
          { code: '353dbc0c-3473-4a62-bacc-08b2e06ebc32', title: '农村物流体系建设' }
        ]
      }
    ]
  },
  {
    title: '农村生态文明建设',
    children: [
      {
        title: '质量兴农绿色兴农',
        children: [
          { code: 'd38567c9-9a22-4318-933f-fdb14d14caa4', title: '农业标准化' },
          { code: '92a8fc1e-2f99-49a2-a4b8-268066e4221f', title: '农产品质量安全监管' },
          { code: '6afca922-2c6a-4991-b4c6-3497b1c15ea4', title: '绿色发展支撑' }
        ]
      },
      {
        title: '农业面源污染防治',
        children: [
          { code: '4236deb7-02b5-4006-b3dd-155650de6e27', title: '化肥农药减量增效' },
          { code: 'e97b443c-85e2-462d-91ab-70f9ccd1e652', title: '农业废弃物循环利用' },
          { code: 'b7295799-269f-4fd8-814b-759adeafc965', title: '污染耕地治理' }
        ]
      },
      {
        title: '农村生态系统保护修复',
        children: [
          { code: 'd8cb4e3a-4606-40f2-b93c-234867bcead8', title: '农业资源保护' },
          { code: '56698efd-2f6a-4828-bdda-84a931f2f2c6', title: '草原森林河流湖泊休养生息制度' },
          { code: 'bc493e17-f44e-4407-be04-c041f60f3cce', title: '农业农村减排固碳' },
          { code: 'f95d13c8-a3a3-405c-ad5c-19a865149642', title: '重点区域生态环境保护' }
        ]
      },
      {
        title: '农村生态文明建设工程',
        children: [
          { code: '92963dd9-4c5a-49a2-b088-1e8815de8c23', title: '耕地土壤污染防治' },
          { code: '5e606ec2-54a6-4d02-b088-51993c3f92dd', title: '耕地轮作休耕制度试点' },
          { code: '3713dd7c-5684-4f4b-8be1-2b572fa450b8', title: '水生生物资源养护行动' },
          { code: 'ce970383-4994-4d1d-acdd-a3b648dad1c3', title: '渔政执法能力建设' },
          { code: '50d1460b-d2b8-4821-9b38-27b26bd9deca', title: '外来入侵物种防控' }
        ]
      }
    ]
  },
  {
    title: '乡村治理',
    children: [
      {
        title: '基层党组织建设',
        children: [
          { code: '19940966-cf2d-4683-9bee-0ea5fc7d06c9', title: '基层党组织' }
        ]
      },
      {
        title: '基层治理',
        children: [
          { code: '32a94db8-a3fb-4b6f-894c-1683f7ef67ca', title: '村民自治' },
          { code: '9d624b91-3bcd-47c8-a06e-a705e8c9c4b0', title: '法治乡村' },
          { code: '89191b84-2192-40da-a007-e1cd679cda4e', title: '乡村德治' },
          { code: '012e3de6-f70d-417b-b790-cda0988eb377', title: '应急管理' }
        ]
      },
      {
        title: '新时代农村精神文明建设',
        children: [
          { code: '5e7d86a5-6508-4546-bf5b-e121a9cc3632', title: '农村思想道德建设' },
          { code: 'c3e4ad20-813f-4b6c-bb43-51e0ee94b593', title: '乡村优秀文化' },
          { code: 'bc01cbe6-4f12-4536-af30-7648d6ba0817', title: '农村移风易俗' }
        ]
      },
      {
        title: '新型农村集体经济',
        children: [
          { code: '018b9de2-49dd-40c7-b4a4-368914f2aade', title: '村级债务' },
          { code: 'c46a4a28-e5b4-470f-ad58-c40b1332cf2c', title: '集体经济形式' }
        ]
      },
      {
        title: '农民增收致富',
        children: [
          { code: '5a8cb2f8-1648-4c96-9ecf-5ce79a256ee4', title: '高素质农民队伍' },
          { code: '973cf602-ea37-4176-9b47-38b666396395', title: '农民创业就业' }
        ]
      },
      {
        title: '现代乡村治理体系建设工程',
        children: [
          { code: 'c2bc91db-9ffb-48dd-a13a-6be2f57f7f4d', title: '村党组织带头人培养' },
          { code: 'abdbdc7d-680e-4d39-bc38-6c65c216e0ed', title: '村级事务阳光工程' },
          { code: '27cd20ce-2d96-4d89-8c78-0f1d80e99f80', title: '乡村治理试点示范行动' },
          { code: 'e4ed2fff-603d-489e-96e6-3e310df35dae', title: '平安乡村建设行动' }
        ]
      }
    ]
  },
  {
    title: '脱贫攻坚成果同乡村振兴有效衔接',
    children: [
      {
        title: '脱贫攻坚成果巩固',
        children: [
          { code: 'd26ac8a5-26c6-4ca5-8d37-87e6c1eb4a99', title: '返贫动态监测' },
          { code: '446c6ca4-d53b-40e6-a86d-e81a5ff15616', title: '两不愁三保障' },
          { code: '23ccb552-d91e-44a0-b47b-b68786fc02ec', title: '易地扶贫搬迁扶持' }
        ]
      },
      {
        title: '精准帮扶机制',
        children: [
          { code: '4f7ac9f5-af7c-4024-9f2a-04988b650a2d', title: '低收入人口帮扶' },
          { code: '70d5e7af-1d58-4d18-b7c0-aaee8aecd9cf', title: '欠发达地区帮扶' },
          { code: '56fcb3eb-ba4d-450b-972b-ba11a7aba3ed', title: '东西部协作帮扶' },
          { code: '335bdf41-a635-4ddc-a5ec-b02e91c8c028', title: '社会力量帮扶' },
          { code: 'ecf6b35b-abfb-4250-8221-0d4af9f14c63', title: '重点帮扶县' }
        ]
      },
      {
        title: '脱贫地区发展',
        children: [
          { code: '0263d2b0-7066-4e11-bed8-82cd43c6eb0d', title: '特色产业可持续发展' },
          { code: '1d6cc7d1-45fc-4892-ab76-52df1783fe3e', title: '脱贫人口稳定就业' },
          { code: 'eb69768e-59bd-4d66-b229-084e5acaf2e6', title: '脱贫地区发展条件改善' }
        ]
      },
      {
        title: '巩固拓展脱贫攻坚成果工程',
        children: [
          { code: '0263d2b0-7066-4e11-bed8-82cd43c6eb0d', title: '特色产业可持续发展' },
          { code: '581d58b2-ac8a-4a24-95ea-ce9f6c670eaf', title: '以工代赈工程' },
          { code: 'b744b14f-dfe1-4f84-89c0-d1c5559b4f46', title: '乡村振兴重点帮扶县集中支持' },
          { code: '636565d7-81fa-45f7-9626-be07a1195d31', title: '定点帮扶' },
          { code: '83f33bba-e0d9-4880-a802-adbe4b0659ed', title: '“万企兴万村”行动' }
        ]
      }
    ]
  },
  {
    title: '农业农村改革',
    children: [
      {
        title: '城乡融合发展',
        children: [
          { code: '26a1a9f0-852b-4ce5-ab6e-8879357ecc0c', title: '县域内城乡融合' },
          { code: '8c4d95f8-2770-457d-9c5e-c3d1854b6a1a', title: '城乡人力资源双向流动' },
          { code: '1bd9919c-da7b-49b2-bc02-85f0542a0b12', title: '城乡土地资源配置' },
          { code: 'd9420d74-8c9f-445f-9135-cb19b94332c8', title: '社会资本投资农业农村' }
        ]
      },
      {
        title: '农村土地制度',
        children: [
          { code: 'b179272a-77d9-4814-9737-0a6d4578a508', title: '农村土地承包管理制度' },
          { code: 'ce2e09ab-3162-4b80-8f9f-364e2f092562', title: '农村宅基地制度改革' },
          { code: '2f12e053-72d2-4030-8280-462304104bde', title: '经营性建设用地入市制度' }
        ]
      },
      {
        title: '农村集体产权制度',
        children: [
          { code: '35cda8ac-1452-488f-b774-0a7f61b29217', title: '农村集体资产管理' },
          { code: '2a102726-e9d3-450f-8f4a-b447f85cad3b', title: '经营性资产股份合作制改革' },
          { code: 'c22c04c0-471d-48c4-a97b-e1d3757e06b2', title: '新型农村集体经济' },
          { code: '664fd9d9-84e3-4b95-9f63-4afca0d7090a', title: '农村产权流转交易管理服务体系' }
        ]
      },
      {
        title: '农业支持保护制度',
        children: [
          { code: 'f8a09414-630f-4738-bb32-92a45f182643', title: '农业补贴政策' },
          { code: '61e8eab3-ad34-4e14-8d77-2a55d97fbfcb', title: '政府投入保障机制' },
          { code: '69292150-abc0-46ad-aece-0e158b1272af', title: '农村金融服务体系' }
        ]
      },
      {
        title: '农村其他改革',
        children: [
          { code: '7eef0913-3497-4a3c-9f88-19b8c17e5d9e', title: '供销合作社综合改革' },
          { code: 'c4a30c71-0efb-4d81-a889-5715866695c9', title: '农垦改革' },
          { code: '4bd0e918-2e63-4395-ae4d-d61455769147', title: '行政执法改革' },
          { code: '4e49236c-d0f3-4ba0-8126-b3ddf7bb1473', title: '农村综合改革' }
        ]
      },
      {
        title: '农业对外开放',
        children: [
          { code: 'c0ab5eda-8ad3-45fc-9582-dd6c578bb758', title: '“一带一路”共建' },
          { code: 'fbfc8a8d-2b7d-4f2c-b44b-638523f57980', title: '国际产能合作' },
          { code: '7cac8665-1ce0-48c8-bc46-14c6734a7f03', title: '农产品“走出去”' }
        ]
      }
    ]
  }
]
